import fe, { useReducer as Pe, useCallback as $, useEffect as V, useState as F, memo as Te, createContext as nn, useMemo as W, useContext as pt, createElement as sn } from "react";
import { Autocomplete as Ue, Box as U, Checkbox as ce, Divider as qe, Chip as on, Grid as x, CheckboxWithOptionsBase as wn, styled as kn, MuiTooltip as Ln, tooltipClasses as Fn, NewTable as je, lighten as Un, Tooltip as be, DropDownMenu as Mn, darken as Ft, Icon as te, Skeleton as zn, Typography as se, StatusTag as an, CheckboxCell as Gn, SelectAllHeaderCell as Hn, ContentBlock as Se, Select as rn, Block as We, Alert as Ct, IconActionButton as ge, IconActionButtonFilled as ht, Spinner as Et, Modal as Ye, useNotifications as St, Input as bt, Button as oe, IconButton as It, Switch as cn, Paper as ye, FilterPanel as Xe, ModalTitle as Nt, InputFilter as mt, AISpinner as $n, Count as Bn } from "@prometheus/components";
import { useRequest as jt, useSelectedConcepts as _e, useDomains as Vn, useFilters as Ut, ModalContext as ln, useFilterOptions as Qn } from "@prometheus/hooks";
import { api as X, getSortDirection as yt, getReducerWithProduce as ve, parseFiltersToStringParams as xt, convertConceptModelToExtendConcept as we, formatFilterListNoFiql as Ze, keyBy as Ne, getStandartConceptType as rt, isEqual as Me, getCookie as Wn, eraseCookie as Yn, setCookie as Kn, formatNumber as tt, getUUID as Dt, groupBy as Ve, convertExtendedToFlatConcepts as dn, convertExtendedConceptsToMap as qn, convertLegacyFlatNewConceptsToExtended as Mt, normalizeAndFilterConcepts as Ie, separateSearchFilters as Je, parseUrlSearchParamsToObject as zt, cleanupSearchParamsObject as Xn, rekeyById as Rt, parseConceptsBySourceCodes as un, parseConceptsById as Zn, debounce as Jn, downloadFile as es, isValidHttpUrl as Gt } from "@prometheus/utils";
import { Status as S, AiSuggestionStatus as Ke } from "@prometheus/types";
import { StandardConceptTypes as xe, mapStandardConceptTypes as ct, TypesOfContainer as De, containerTypes as ts, TypeOfImportConcepts as ze, TypesOfRelatedConcepts as Ht, VocabularyConceptTabs as Ae, ImportConceptsTabs as me, TypesOfIncluded as Qe } from "@prometheus/enums";
import { useLocalStorage as pn, TitleWithCount as Fe, SpinnerWidgetContainer as At, InfoIcon as Pt, ListHeaderPrimary as ns, FloatingButton as vt, IconButton as Cn, TabsNavigationNew as hn, CodeEditor as ss, FileContentType as os, Count as as, FormElement as nt } from "@prometheus/features";
import Q from "@emotion/styled";
import { useSelector as wt, useDispatch as rs } from "react-redux";
import { useSearchParams as cs, Outlet as ls, useNavigate as Ge, useLocation as et, useParams as is, Link as ds, Routes as En, Route as at } from "react-router-dom";
import { setBreadcrumbs as us } from "@prometheus/redux";
var Ot = { exports: {} }, He = {};
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var $t;
function ps() {
  if ($t) return He;
  $t = 1;
  var t = Symbol.for("react.transitional.element"), n = Symbol.for("react.fragment");
  function s(a, c, d) {
    var C = null;
    if (d !== void 0 && (C = "" + d), c.key !== void 0 && (C = "" + c.key), "key" in c) {
      d = {};
      for (var h in c)
        h !== "key" && (d[h] = c[h]);
    } else d = c;
    return c = d.ref, {
      $$typeof: t,
      type: a,
      key: C,
      ref: c !== void 0 ? c : null,
      props: d
    };
  }
  return He.Fragment = n, He.jsx = s, He.jsxs = s, He;
}
var $e = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Bt;
function Cs() {
  return Bt || (Bt = 1, process.env.NODE_ENV !== "production" && function() {
    function t(T) {
      if (T == null) return null;
      if (typeof T == "function")
        return T.$$typeof === b ? null : T.displayName || T.name || null;
      if (typeof T == "string") return T;
      switch (T) {
        case m:
          return "Fragment";
        case R:
          return "Profiler";
        case u:
          return "StrictMode";
        case N:
          return "Suspense";
        case v:
          return "SuspenseList";
        case I:
          return "Activity";
      }
      if (typeof T == "object")
        switch (typeof T.tag == "number" && console.error(
          "Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."
        ), T.$$typeof) {
          case g:
            return "Portal";
          case P:
            return (T.displayName || "Context") + ".Provider";
          case y:
            return (T._context.displayName || "Context") + ".Consumer";
          case j:
            var _ = T.render;
            return T = T.displayName, T || (T = _.displayName || _.name || "", T = T !== "" ? "ForwardRef(" + T + ")" : "ForwardRef"), T;
          case w:
            return _ = T.displayName || null, _ !== null ? _ : t(T.type) || "Memo";
          case f:
            _ = T._payload, T = T._init;
            try {
              return t(T(_));
            } catch {
            }
        }
      return null;
    }
    function n(T) {
      return "" + T;
    }
    function s(T) {
      try {
        n(T);
        var _ = !1;
      } catch {
        _ = !0;
      }
      if (_) {
        _ = console;
        var O = _.error, A = typeof Symbol == "function" && Symbol.toStringTag && T[Symbol.toStringTag] || T.constructor.name || "Object";
        return O.call(
          _,
          "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.",
          A
        ), n(T);
      }
    }
    function a(T) {
      if (T === m) return "<>";
      if (typeof T == "object" && T !== null && T.$$typeof === f)
        return "<...>";
      try {
        var _ = t(T);
        return _ ? "<" + _ + ">" : "<...>";
      } catch {
        return "<...>";
      }
    }
    function c() {
      var T = M.A;
      return T === null ? null : T.getOwner();
    }
    function d() {
      return Error("react-stack-top-frame");
    }
    function C(T) {
      if (k.call(T, "key")) {
        var _ = Object.getOwnPropertyDescriptor(T, "key").get;
        if (_ && _.isReactWarning) return !1;
      }
      return T.key !== void 0;
    }
    function h(T, _) {
      function O() {
        Z || (Z = !0, console.error(
          "%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)",
          _
        ));
      }
      O.isReactWarning = !0, Object.defineProperty(T, "key", {
        get: O,
        configurable: !0
      });
    }
    function E() {
      var T = t(this.type);
      return le[T] || (le[T] = !0, console.error(
        "Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release."
      )), T = this.props.ref, T !== void 0 ? T : null;
    }
    function r(T, _, O, A, D, z, ie, Ce) {
      return O = z.ref, T = {
        $$typeof: p,
        type: T,
        key: _,
        props: z,
        _owner: D
      }, (O !== void 0 ? O : null) !== null ? Object.defineProperty(T, "ref", {
        enumerable: !1,
        get: E
      }) : Object.defineProperty(T, "ref", { enumerable: !1, value: null }), T._store = {}, Object.defineProperty(T._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: 0
      }), Object.defineProperty(T, "_debugInfo", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: null
      }), Object.defineProperty(T, "_debugStack", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: ie
      }), Object.defineProperty(T, "_debugTask", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: Ce
      }), Object.freeze && (Object.freeze(T.props), Object.freeze(T)), T;
    }
    function l(T, _, O, A, D, z, ie, Ce) {
      var q = _.children;
      if (q !== void 0)
        if (A)
          if (H(q)) {
            for (A = 0; A < q.length; A++)
              i(q[A]);
            Object.freeze && Object.freeze(q);
          } else
            console.error(
              "React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead."
            );
        else i(q);
      if (k.call(_, "key")) {
        q = t(T);
        var he = Object.keys(_).filter(function(ke) {
          return ke !== "key";
        });
        A = 0 < he.length ? "{key: someKey, " + he.join(": ..., ") + ": ...}" : "{key: someKey}", re[q + A] || (he = 0 < he.length ? "{" + he.join(": ..., ") + ": ...}" : "{}", console.error(
          `A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`,
          A,
          q,
          he,
          q
        ), re[q + A] = !0);
      }
      if (q = null, O !== void 0 && (s(O), q = "" + O), C(_) && (s(_.key), q = "" + _.key), "key" in _) {
        O = {};
        for (var Re in _)
          Re !== "key" && (O[Re] = _[Re]);
      } else O = _;
      return q && h(
        O,
        typeof T == "function" ? T.displayName || T.name || "Unknown" : T
      ), r(
        T,
        q,
        z,
        D,
        c(),
        O,
        ie,
        Ce
      );
    }
    function i(T) {
      typeof T == "object" && T !== null && T.$$typeof === p && T._store && (T._store.validated = 1);
    }
    var o = fe, p = Symbol.for("react.transitional.element"), g = Symbol.for("react.portal"), m = Symbol.for("react.fragment"), u = Symbol.for("react.strict_mode"), R = Symbol.for("react.profiler"), y = Symbol.for("react.consumer"), P = Symbol.for("react.context"), j = Symbol.for("react.forward_ref"), N = Symbol.for("react.suspense"), v = Symbol.for("react.suspense_list"), w = Symbol.for("react.memo"), f = Symbol.for("react.lazy"), I = Symbol.for("react.activity"), b = Symbol.for("react.client.reference"), M = o.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, k = Object.prototype.hasOwnProperty, H = Array.isArray, Y = console.createTask ? console.createTask : function() {
      return null;
    };
    o = {
      react_stack_bottom_frame: function(T) {
        return T();
      }
    };
    var Z, le = {}, ae = o.react_stack_bottom_frame.bind(
      o,
      d
    )(), K = Y(a(d)), re = {};
    $e.Fragment = m, $e.jsx = function(T, _, O, A, D) {
      var z = 1e4 > M.recentlyCreatedOwnerStacks++;
      return l(
        T,
        _,
        O,
        !1,
        A,
        D,
        z ? Error("react-stack-top-frame") : ae,
        z ? Y(a(T)) : K
      );
    }, $e.jsxs = function(T, _, O, A, D) {
      var z = 1e4 > M.recentlyCreatedOwnerStacks++;
      return l(
        T,
        _,
        O,
        !0,
        A,
        D,
        z ? Error("react-stack-top-frame") : ae,
        z ? Y(a(T)) : K
      );
    };
  }()), $e;
}
process.env.NODE_ENV === "production" ? Ot.exports = ps() : Ot.exports = Cs();
var e = Ot.exports;
const hs = (t) => {
  const { pageNumber: n, pageSize: s, sortBy: a, query: c } = t, d = yt(a), C = `/concepts/list?${c}&size=${s || ""}&page=${n || ""}&sort=${d}`;
  return X.get(C);
}, Es = (t, n = !1, s, a) => {
  const { pageNumber: c, pageSize: d, sortBy: C, query: h } = a, E = yt(C), l = (n ? `/concepts/concept/${s}/non-standard/${t}/list` : `/concepts/concept/${s}/${t}`) + `?size=${d || ""}&page=${c || ""}&sort=${E}&${h || ""}`;
  return X.get(l);
}, Ss = (t) => {
  const n = `/concepts/filter?${t}`;
  return X.get(n);
}, ms = (t, n) => (s) => {
  const c = `/concepts/concept/${t}/${n ? "non-standard/" : ""}ancestors/filter?${s}`;
  return X.get(c);
}, xs = (t, n) => (s) => {
  const c = `/concepts/concept/${t}/${n ? "non-standard/" : ""}descendants/filter?${s}`;
  return X.get(c);
}, Sn = (t) => X.post("/concepts/lookup/identifiers?size=1000000", t), mn = (t) => X.post("/concepts/lookup/sourcecodes?size=1000000", t), _s = (t) => X.get(`/concepts/concept/${t}`), gs = (t, n, s) => {
  const a = s ? `sort=${yt(s)}` : "";
  return X.get(
    `/concepts/${t}/related/list?${a}${n ? "&" + n : ""}`
  );
}, xn = (t) => X.post("/concepts", t || []), fs = (t) => (n) => X.get(`/concepts/${t}/related/filter?${n}`), Ts = () => X.get("/concepts/vocabulary-version"), Is = () => X.get("/data-sources/with-record-counts"), Rs = (t) => X.get(`/data-sources/default/${t}`), Os = (t, n) => X.post(`/conceptset/suggestion/${t}`, n), bs = (t, n) => X.post(
  `/conceptset/suggestion/${t}/list`,
  {}
);
var ee = /* @__PURE__ */ ((t) => (t.UPDATE_PAGE_NUMBER = "UPDATE_PAGE_NUMBER", t.UPDATE_QUERY = "UPDATE_QUERY", t.UPDATE_ADVANCED_SEARCH = "UPDATE_ADVANCED_SEARCH", t.UPDATE_FILTERS = "UPDATE_FILTERS", t.RESET_FILTERS = "RESET_FILTERS", t.SEARCH_REQUEST = "SEARCH_REQUEST", t.SEARCH_REQUEST_DONE = "SEARCH_REQUEST_DONE", t.SEARCH_REQUEST_FAILED = "SEARCH_REQUEST_FAILED", t.CLEAR_SEARCH = "CLEAR_SEARCH", t.UPDATE_SEARCH_PARAMS = "UPDATE_SEARCH_PARAMS", t.SAVE_SETTINGS = "SAVE_SETTINGS", t.SET_SIZE = "SET_SIZE", t))(ee || {});
const Ns = (t, n) => ve(t, (s) => {
  var a, c, d;
  switch (n.type) {
    case ee.UPDATE_QUERY:
      s.searchParams.searchQuery = n.payload;
      break;
    case ee.UPDATE_ADVANCED_SEARCH:
      s.searchParams.advancedSearch = n.payload;
      break;
    case ee.UPDATE_FILTERS:
      s.searchParams.searchFilters = {
        ...s.searchParams.searchFilters,
        ...n.payload
      };
      break;
    case ee.RESET_FILTERS: {
      s.searchParams.searchFilters = {};
      break;
    }
    case ee.UPDATE_SEARCH_PARAMS:
      s.searchParams = {
        searchQuery: (a = n.payload.fullSearch) == null ? void 0 : a[0],
        advancedSearch: (c = n.payload.advancedSearch) == null ? void 0 : c[0],
        searchFilters: n.payload,
        pageNumber: ((d = n.payload.pageNumber) == null ? void 0 : d[0]) || 0
      };
      break;
    case ee.SEARCH_REQUEST:
      s.status = s.status === S.INITIAL ? S.IN_PROGRESS : S.IN_PROGRESS_RELOAD;
      break;
    case ee.SEARCH_REQUEST_DONE:
      s.status = S.SUCCESS;
      const { data: C, filters: h } = n.payload;
      s.filters = h, s.searchData = C.content, s.pageCount = C.totalPages || 1, s.numberOfElements = C.numberOfElements, s.totalElements = C.totalElements;
      break;
    case ee.SEARCH_REQUEST_FAILED:
      s.status = S.ERROR;
      break;
    case ee.CLEAR_SEARCH:
      s.searchParams.searchQuery = "", s.searchParams.searchFilters = null, s.searchParams.pageNumber = 0, s.searchData = [], s.pageCount = 1, s.pageSize = 10, s.numberOfElements = 0, s.totalElements = 0, s.status = S.INITIAL;
      break;
    case ee.SAVE_SETTINGS:
      s.pageSize = n.payload.pageSize, s.searchParams.searchFilters = n.payload.filters;
      break;
  }
}), Vt = {
  searchParams: {
    advancedSearch: !1,
    searchQuery: "",
    searchFilters: {},
    pageNumber: 0
  },
  searchData: [],
  pageCount: 1,
  pageSize: 10,
  numberOfElements: 0,
  totalElements: 0,
  status: S.INITIAL,
  filters: []
}, kt = (t, n, s, a) => {
  const [c, d] = Pe(Ns, {
    ...Vt,
    searchParams: {
      ...Vt.searchParams,
      searchFilters: a == null ? void 0 : a.filters,
      advancedSearch: a == null ? void 0 : a.advancedSearch
    },
    pageSize: a == null ? void 0 : a.pageSize
  }), C = (o) => {
    d({
      type: ee.UPDATE_QUERY,
      payload: o
    });
  }, h = (o) => {
    d({
      type: ee.UPDATE_ADVANCED_SEARCH,
      payload: o
    });
  }, E = (o) => {
    d({
      type: ee.UPDATE_FILTERS,
      payload: o
    });
  }, r = () => {
    d({
      type: ee.RESET_FILTERS
    });
  }, l = (o) => {
    d({
      type: ee.UPDATE_SEARCH_PARAMS,
      payload: o
    });
  }, i = $(
    async (o = c.searchParams.pageNumber, p = c.pageSize, g, m = !1) => {
      m || d({ type: ee.SEARCH_REQUEST });
      try {
        const { searchFilters: u, advancedSearch: R, searchQuery: y } = c.searchParams, P = xt({
          ...u,
          ...y != null && {
            [R ? "advancedSearch" : "fullSearch"]: [y]
          }
        }), [j, N] = await Promise.all([
          hs({
            query: P,
            pageNumber: o,
            pageSize: p,
            sortBy: g
          }).then((v) => ({
            ...v,
            content: v.content.map(
              (w) => we(w)
            )
          })),
          t || m ? Promise.resolve([]) : Ss(P).then(Ze)
        ]);
        if (m)
          return Ne(j.content, "conceptId");
        d({
          type: ee.SEARCH_REQUEST_DONE,
          payload: { data: j, filters: N }
        });
      } catch (u) {
        console.error(u), d({
          type: ee.SEARCH_REQUEST_FAILED
        });
      }
    },
    [c.searchParams]
  );
  return V(() => {
    n != null && n != "" && E({ "filter.domain": [n] });
  }, [n]), V(() => {
    s != null && s != "" && E({ "filter.standard.concept": [s] });
  }, [s]), {
    ...c,
    search: i,
    updateQuery: C,
    updateFilters: E,
    updateSearchParams: l,
    resetFilters: r,
    updateAdvancedSearch: h
  };
}, js = ({
  onAdd: t,
  domainId: n,
  standard: s,
  // TODO
  value: a,
  placeholder: c,
  showSelectAll: d = !0
}) => {
  const [C, h] = F(!1), { searchData: E, search: r, status: l } = kt(!0, n, null, {
    filters: {
      "filter.standard.concept": ["Standard"],
      "filter.domain": [n]
    }
  });
  V(() => {
    r(0, 1e4, null);
  }, []), V(() => {
    h(
      d && (a == null ? void 0 : a.length) !== 0 && (a == null ? void 0 : a.length) === (E == null ? void 0 : E.length)
    );
  }, [d, a, E]);
  const i = (m) => {
    m.preventDefault(), t(C ? [] : E.map((u) => u.concept));
  }, o = (m) => (m == null ? void 0 : m.value) === "selectAll", p = E.map((m) => m.concept).sort((m, u) => (m.CONCEPT_NAME || "").localeCompare(u.CONCEPT_NAME || "")), g = d ? [{ name: "Select all", value: "selectAll" }, ...p] : p;
  return /* @__PURE__ */ e.jsx(
    Ue,
    {
      fullWidth: !0,
      multiple: !0,
      options: g,
      value: a,
      isOptionEqualToValue: (m, u) => m.CONCEPT_ID === u.CONCEPT_ID,
      placeholder: c || "Select concept or enter concept name...",
      onChange: function(m, u) {
        if (u.some(o)) {
          i(m);
          return;
        }
        t(u);
      },
      getOptionLabel: function(m) {
        return m.CONCEPT_NAME || m.name;
      },
      limitTags: 50,
      disableCloseOnSelect: !0,
      loading: l === S.IN_PROGRESS || l === S.IN_PROGRESS_RELOAD,
      renderValue: (m, u) => /* @__PURE__ */ e.jsx(on, { label: m.CONCEPT_NAME || m.name, ...u() }),
      OptionComponent: (m, u, { selected: R }) => {
        var y;
        return [
          /* @__PURE__ */ e.jsxs(
            U,
            {
              ...m,
              sx: { fontSize: 13, height: "28px" },
              onClick: d && o(u) ? i : m.onClick,
              children: [
                /* @__PURE__ */ e.jsx(
                  ce,
                  {
                    sx: { mr: 1 },
                    checked: d && o(u) ? C : R,
                    size: "small"
                  }
                ),
                ((y = u.concept) == null ? void 0 : y.CONCEPT_NAME) || u.CONCEPT_NAME || u.name
              ]
            }
          ),
          d && o(u) ? /* @__PURE__ */ e.jsx(qe, {}, "divider") : ""
        ];
      }
    }
  );
}, ys = {
  DOMAIN_ID_TITLE: "Domain",
  CONCEPT_CLASS_ID_TITLE: "Class",
  VOCABULARY_ID_TITLE: "Vocabulary",
  CONCEPT_ID_TITLE: "Id",
  CONCEPT_CODE_TITLE: "Code",
  INVALID_REASON_CAPTION_TITLE: "Invalid reason",
  EXCLUDE_TITLE: "Exclude",
  MAPPED_TITLE: "Mapped",
  DESCENDANTS_TITLE: "Descendants",
  HIERARCHY_TITLE: "Hierarchy"
}, Ds = Q.div`
border-top: 1px solid #e3e3e3;
    padding: 15px 15px 0px;
    background: #ffffff;
    padding-top: 15px;

.details-item-extra-margin {
    margin-bottom:20px !important;
}

.details-item-action {
    margin-bottom: 2px !important;
    label {
        margin-left: 10px;
        display: inline-block !important;
    }
}

.details-item {
    font-size: 12px;
    margin-bottom: 10px;
    color: #323232;

    label {
        color: ${({ theme: t }) => {
  var n;
  return (n = t.palette) == null ? void 0 : n.primary.main;
}};
        font-weight: 700;
        width: 130px;
        display: block;
    }
    

    span {
        display: inline-block;
    }
}

    h3 {
        margin: 0;
        margin-bottom: 5px;
        font-size: 16px;
    }

    .header-info {
        margin-bottom: 20px;
    }

    .details-ids {
        margin-right: 10px;
        margin-bottom: 20px;
        font-size: 14px;
        label {
            font-weight: 700;
        }
        p {
            margin: 0
            margin-top:5px;
        }
    }

    .action-info {
        font-size: 14px;
        margin-right: 10px;
    }

`, As = Te((t) => {
  const { concept: n, onEditAction: s, clearConceptSettings: a, canEdit: c } = t, [d, C] = F(n), {
    concept: {
      CONCEPT_ID: h,
      CONCEPT_CODE: E,
      CONCEPT_CLASS_ID: r,
      VOCABULARY_ID: l,
      DOMAIN_ID: i,
      INVALID_REASON_CAPTION: o,
      STANDARD_CONCEPT_CAPTION: p
    },
    excluded: g,
    descendants: m,
    mapped: u,
    hierarchy: R
  } = d, {
    CONCEPT_ID_TITLE: y,
    CONCEPT_CODE_TITLE: P,
    CONCEPT_CLASS_ID_TITLE: j,
    DOMAIN_ID_TITLE: N,
    VOCABULARY_ID_TITLE: v,
    INVALID_REASON_CAPTION_TITLE: w,
    EXCLUDE_TITLE: f,
    DESCENDANTS_TITLE: I,
    MAPPED_TITLE: b,
    HIERARCHY_TITLE: M
  } = ys;
  V(() => {
    a && C(n);
  }, [a]), V(() => {
    n.conceptId !== h && C(n);
  }, [n]);
  const k = (H) => {
    const Y = {
      ...d,
      [H]: !d[H]
    };
    C(Y), s(Y);
  };
  return /* @__PURE__ */ e.jsx(Ds, { children: /* @__PURE__ */ e.jsxs(x, { container: !0, children: [
    /* @__PURE__ */ e.jsx(x, { item: !0, xs: 9, children: /* @__PURE__ */ e.jsxs(x, { container: !0, children: [
      /* @__PURE__ */ e.jsxs(x, { item: !0, xs: 4, children: [
        /* @__PURE__ */ e.jsxs("div", { className: "details-item details-item-extra-margin", children: [
          /* @__PURE__ */ e.jsx("label", { children: y }),
          /* @__PURE__ */ e.jsx("span", { children: h })
        ] }),
        /* @__PURE__ */ e.jsxs("div", { className: "details-item details-item-extra-margin", children: [
          /* @__PURE__ */ e.jsx("label", { children: P }),
          /* @__PURE__ */ e.jsx("span", { children: E })
        ] })
      ] }),
      /* @__PURE__ */ e.jsxs(x, { item: !0, xs: 4, children: [
        /* @__PURE__ */ e.jsxs("div", { className: "details-item details-item-extra-margin", children: [
          /* @__PURE__ */ e.jsx("label", { children: N }),
          /* @__PURE__ */ e.jsx("span", { children: i })
        ] }),
        /* @__PURE__ */ e.jsxs("div", { className: "details-item details-item-extra-margin", children: [
          /* @__PURE__ */ e.jsx("label", { children: v }),
          /* @__PURE__ */ e.jsx("span", { children: l })
        ] })
      ] }),
      /* @__PURE__ */ e.jsxs(x, { item: !0, xs: 4, children: [
        /* @__PURE__ */ e.jsxs("div", { className: "details-item details-item-extra-margin", children: [
          /* @__PURE__ */ e.jsx("label", { children: w }),
          /* @__PURE__ */ e.jsx("span", { children: o })
        ] }),
        /* @__PURE__ */ e.jsxs("div", { className: "details-item details-item-extra-margin", children: [
          /* @__PURE__ */ e.jsx("label", { children: j }),
          /* @__PURE__ */ e.jsx("span", { children: r })
        ] })
      ] })
    ] }) }),
    c && /* @__PURE__ */ e.jsxs(x, { item: !0, xs: 3, children: [
      /* @__PURE__ */ e.jsxs("div", { className: "details-item details-item-action", children: [
        /* @__PURE__ */ e.jsx(
          ce,
          {
            name: "excluded",
            checked: g,
            onChange: () => k("excluded")
          }
        ),
        /* @__PURE__ */ e.jsx("label", { children: f })
      ] }),
      /* @__PURE__ */ e.jsxs("div", { className: "details-item details-item-action", children: [
        /* @__PURE__ */ e.jsx(
          ce,
          {
            name: "descendants",
            checked: m,
            onChange: () => k("descendants"),
            disabled: p === xe.NON_STANDARD_CAPTION
          }
        ),
        /* @__PURE__ */ e.jsx("label", { children: I })
      ] }),
      /* @__PURE__ */ e.jsxs("div", { className: "details-item details-item-action", children: [
        /* @__PURE__ */ e.jsx(
          ce,
          {
            name: "mapped",
            checked: u,
            onChange: () => k("mapped"),
            disabled: p === xe.NON_STANDARD_CAPTION
          }
        ),
        /* @__PURE__ */ e.jsx("label", { children: b })
      ] }),
      /* @__PURE__ */ e.jsxs("div", { className: "details-item details-item-action", children: [
        /* @__PURE__ */ e.jsx(
          ce,
          {
            name: "hierarchy",
            checked: R,
            onChange: () => k("hierarchy"),
            disabled: p === xe.STANDARD_CAPTION
          }
        ),
        /* @__PURE__ */ e.jsx("label", { children: M })
      ] })
    ] })
  ] }) });
}), Ps = (t) => X.post("/conceptset/optimize", t), vs = (t) => X.post("/concepts/related-standard", t), ws = (t) => X.post("/workspace/concept-sets", t), ks = (t, n) => X.post(`/studies/${t}/concept-sets`, n), _n = nn(null), gn = ({ selectedRows: t, setSelectedRows: n, children: s }) => {
  const a = W(
    () => ({ selectedRows: t, setSelectedRows: n }),
    [t, n]
  );
  return /* @__PURE__ */ e.jsx(_n.Provider, { value: a, children: s });
}, Qt = (t) => (t || []).flat().map((n) => n._id), Wt = (t, n) => {
  const s = t.filter((a) => n[a]).length;
  return {
    checked: t.length > 0 && s === t.length,
    indeterminate: s > 0 && s < t.length,
    disabled: t.length === 0
  };
}, Ls = ({
  table: t
}) => {
  const n = pt(_n);
  if (!n || !t)
    return null;
  const { selectedRows: s, setSelectedRows: a } = n, c = Qt(t.options.data), d = Qt(
    t.getRowModel().rows.map((h) => h.original)
  ), C = (h) => (...E) => {
    const r = !!E[1], l = h === "page" ? d : c;
    a((i) => {
      const o = { ...i };
      return l.forEach((p) => {
        r ? o[p] = !0 : delete o[p];
      }), o;
    });
  };
  return /* @__PURE__ */ e.jsx(
    wn,
    {
      state: {
        all: Wt(c, s),
        page: Wt(d, s)
      },
      canSelectAll: !0,
      onChange: C
    }
  );
}, lt = (t = "select") => ({
  header: Ls,
  id: t,
  // Fits the mass-selection checkbox together with its drop-down arrow.
  size: 56,
  maxSize: 56,
  enableResizing: !1,
  enableSorting: !1,
  enableHiding: !1,
  meta: {
    columnType: "action",
    align: "left",
    headerAlign: "left"
  }
}), it = (t) => ({
  header: "Id",
  id: t,
  enableColumnFilter: !1,
  enableSorting: !1,
  size: 100,
  enableHiding: !1
}), dt = (t) => ({
  header: "Code",
  id: t,
  size: 100,
  enableColumnFilter: !1,
  enableSorting: !1
}), ut = (t) => ({
  header: "Name",
  id: t,
  size: 300,
  minSize: 120,
  sortingFn: "custom",
  enableSorting: !1
}), fn = {
  header: "",
  id: "arrow",
  enableResizing: !1,
  enableColumnFilter: !1,
  enableHiding: !1,
  enableSorting: !1,
  size: 30,
  meta: {
    align: "center"
  }
}, Fs = [
  {
    header: "Non-Standard",
    enableHiding: !1,
    id: "non-standard",
    columns: [
      lt("actions"),
      it("conceptId___non-standard"),
      dt("conceptCode___non-standard"),
      ut("conceptName___non-standard"),
      fn
    ]
  },
  {
    header: "Standard",
    id: "standard",
    enableHiding: !1,
    columns: [
      lt(),
      it("conceptId___standard"),
      dt("conceptCode___standard"),
      ut("conceptName___standard")
    ]
  }
], Us = kn(({ className: t, ...n }) => /* @__PURE__ */ e.jsx(Ln, { width: "auto", classes: { popper: t }, ...n }))({
  [`& .${Fn.tooltip}`]: {
    maxWidth: "500px"
  }
}), Ms = ({
  to: t,
  from: n,
  children: s
}) => /* @__PURE__ */ e.jsx(
  Us,
  {
    title: n ? /* @__PURE__ */ e.jsxs(x, { container: !0, width: t ? 440 : 300, alignItems: "flex-end", children: [
      /* @__PURE__ */ e.jsxs(x, { item: !0, xs: 12, display: "flex", children: [
        /* @__PURE__ */ e.jsx(
          Yt,
          {
            width: t ? "calc(100% - 20px)" : "100%",
            concept: n
          }
        ),
        t && [
          /* @__PURE__ */ e.jsx(x, { item: !0, width: "40px", margin: "auto 0", px: 0.5 }),
          /* @__PURE__ */ e.jsx(Yt, { width: "calc(100% - 20px)", concept: t })
        ]
      ] }),
      /* @__PURE__ */ e.jsxs(x, { item: !0, xs: 12, display: "flex", children: [
        /* @__PURE__ */ e.jsx(x, { item: !0, width: "calc(100% - 20px)", children: /* @__PURE__ */ e.jsx(Kt, { concept: n }) }),
        t && [
          /* @__PURE__ */ e.jsx(x, { item: !0, width: "40px", margin: "auto 0", px: 0.5, children: "→" }),
          /* @__PURE__ */ e.jsx(x, { item: !0, width: "calc(100% - 20px)", children: /* @__PURE__ */ e.jsx(Kt, { concept: t }) })
        ]
      ] })
    ] }) : "",
    followCursor: !0,
    children: s
  }
), Yt = ({
  concept: t,
  width: n
}) => {
  const s = rt(t == null ? void 0 : t.STANDARD_CONCEPT);
  return /* @__PURE__ */ e.jsxs(
    x,
    {
      item: !0,
      width: n,
      sx: {
        display: "flex",
        justifyContent: "space-between",
        borderBottom: "1px solid #ffffff80",
        pb: 1,
        mb: 1,
        alignItems: "baseline"
      },
      children: [
        /* @__PURE__ */ e.jsx(U, { fontSize: 13, children: /* @__PURE__ */ e.jsx("b", { children: t == null ? void 0 : t.CONCEPT_NAME }) }),
        /* @__PURE__ */ e.jsx(
          U,
          {
            component: "span",
            sx: {
              bgcolor: s.color,
              px: 0.5,
              py: 0.25,
              borderRadius: 0.5,
              whiteSpace: "nowrap"
            },
            children: s == null ? void 0 : s.caption
          }
        )
      ]
    }
  );
}, Kt = ({ concept: t }) => /* @__PURE__ */ e.jsxs(x, { container: !0, fontSize: 12, spacing: 0.5, children: [
  /* @__PURE__ */ e.jsxs(x, { item: !0, xs: 12, children: [
    /* @__PURE__ */ e.jsx(U, { component: "span", mr: 1, children: /* @__PURE__ */ e.jsx("b", { children: "Id:" }) }),
    /* @__PURE__ */ e.jsx(U, { component: "span", children: t == null ? void 0 : t.CONCEPT_ID })
  ] }),
  /* @__PURE__ */ e.jsxs(x, { item: !0, xs: 12, children: [
    /* @__PURE__ */ e.jsx(U, { component: "span", mr: 1, children: /* @__PURE__ */ e.jsx("b", { children: "Code:" }) }),
    /* @__PURE__ */ e.jsx(U, { component: "span", children: t == null ? void 0 : t.CONCEPT_CODE })
  ] }),
  /* @__PURE__ */ e.jsxs(x, { item: !0, xs: 12, children: [
    /* @__PURE__ */ e.jsx(U, { component: "span", mr: 1, children: /* @__PURE__ */ e.jsx("b", { children: "Class:" }) }),
    /* @__PURE__ */ e.jsx(U, { component: "span", children: t == null ? void 0 : t.CONCEPT_CLASS_ID })
  ] }),
  /* @__PURE__ */ e.jsxs(x, { item: !0, xs: 12, children: [
    /* @__PURE__ */ e.jsx(U, { component: "span", mr: 1, children: /* @__PURE__ */ e.jsx("b", { children: "Domain:" }) }),
    /* @__PURE__ */ e.jsx(U, { component: "span", children: t == null ? void 0 : t.DOMAIN_ID })
  ] }),
  /* @__PURE__ */ e.jsxs(x, { item: !0, xs: 12, children: [
    /* @__PURE__ */ e.jsx(U, { component: "span", mr: 1, children: /* @__PURE__ */ e.jsx("b", { children: "Vocabulary:" }) }),
    /* @__PURE__ */ e.jsx(U, { component: "span", children: t == null ? void 0 : t.VOCABULARY_ID })
  ] })
] }), ne = (t) => /* @__PURE__ */ e.jsx(Ms, { from: t.row, children: /* @__PURE__ */ e.jsx(zs, { styles: { ...t.styles }, className: "td", ...t, children: t.children }) }), zs = Q("td")(({ styles: t }) => ({
  ...t
})), gt = ({
  selectedRows: t,
  data: n,
  setSelectedRows: s,
  setActiveRow: a,
  activeRow: c
}) => {
  const d = (r) => {
    const l = {
      [r.from.id]: !0,
      [r.to.CONCEPT_ID]: !0
    };
    !Me(l, c) && a(l);
  }, C = (r) => {
    const l = r.reduce((i, o) => (i[o.from.id] = !0, i[o.to.CONCEPT_ID] = !0, i), {});
    !Me(l, c) && a(l);
  }, h = (r) => (l) => ({
    onMouseOver: () => d(r),
    // onMouseLeave: onHoverOut,
    className: "td",
    styles: {
      color: c != null && c[r.from.id] && (c != null && c[r.to.CONCEPT_ID]) ? Un(
        0.05,
        ct.get(xe.STANDARD).color
      ) : void 0,
      ...l
    }
  }), E = (r, l, i) => (o, p = !1) => ({
    onMouseOver: () => C(r),
    // onMouseLeave: onHoverOut,
    className: "td",
    rowSpan: i,
    styles: {
      color: c != null && c[l.from.id] && !p ? ct.get(xe.NON_STANDARD).color : void 0,
      ...o
    }
  });
  return /* @__PURE__ */ e.jsx(U, { onMouseLeave: () => a(null), children: /* @__PURE__ */ e.jsx(
    gn,
    {
      selectedRows: t,
      setSelectedRows: s,
      children: /* @__PURE__ */ e.jsx(
        je,
        {
          data: n,
          getRowId: (r) => r._id,
          withDuplicates: !0,
          hideSettings: !0,
          customTableRow: ({ data: r, row: l, ...i }) => {
            const o = r.length + 1, p = r.every(
              (u) => t[u._id]
            ), g = r.some(
              (u) => t[u._id]
            ), m = l.getVisibleCells().map((u) => ({
              width: u.column.getCanResize() ? "auto" : u.column.getSize(),
              maxWidth: u.column.getSize(),
              minWidth: u.column.getSize(),
              overflowX: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap"
            }));
            return /* @__PURE__ */ e.jsx(
              U,
              {
                component: "tbody",
                className: "tbody",
                sx: {
                  "&.tbody:hover .tr": {
                    backgroundColor: "#2183d91a"
                  }
                },
                children: r.map((u, R) => {
                  const y = h(u), P = E(
                    r,
                    u,
                    o
                  );
                  return (
                    // <ConceptPreviewTooltip
                    //   from={row.from}
                    //   to={row.to}
                    //   key={row._id}
                    // >
                    /* @__PURE__ */ sn(U, { ...i, component: "tr", key: u._id }, R === 0 ? /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
                      /* @__PURE__ */ e.jsx(
                        ne,
                        {
                          className: "td",
                          rowSpan: o,
                          styles: { ...m[0], textOverflow: "unset" },
                          children: /* @__PURE__ */ e.jsx(
                            ce,
                            {
                              size: "small",
                              sx: { mt: -0.5 },
                              checked: p,
                              indeterminate: g && !p,
                              onChange: (j, N) => {
                                s((v) => ({
                                  ...v,
                                  ...r.reduce((w, f) => (w[f._id] = N, w), {})
                                }));
                              }
                            }
                          )
                        }
                      ),
                      /* @__PURE__ */ e.jsx(
                        ne,
                        {
                          ...P(m[1]),
                          row: u.from,
                          children: u.from.CONCEPT_ID
                        }
                      ),
                      /* @__PURE__ */ e.jsx(
                        ne,
                        {
                          ...P(m[2]),
                          row: u.from,
                          children: u.from.CONCEPT_CODE
                        }
                      ),
                      /* @__PURE__ */ e.jsx(
                        ne,
                        {
                          ...P(m[3]),
                          row: u.from,
                          children: u.from.CONCEPT_NAME
                        }
                      ),
                      /* @__PURE__ */ e.jsx(
                        ne,
                        {
                          rowSpan: o,
                          className: "td",
                          ...P(
                            { ...m[4], pointerEvents: "none" },
                            !0
                          ),
                          children: "→"
                        }
                      )
                    ] }) : /* @__PURE__ */ e.jsx(e.Fragment, {}), /* @__PURE__ */ e.jsx(
                      ne,
                      {
                        className: "td",
                        style: {
                          ...m[5],
                          textOverflow: "unset"
                        },
                        children: /* @__PURE__ */ e.jsx(
                          ce,
                          {
                            size: "small",
                            sx: { mt: -0.5 },
                            checked: t[u._id] || !1,
                            onChange: (j, N) => {
                              s((v) => ({
                                ...v,
                                [u._id]: N
                              }));
                            }
                          }
                        )
                      }
                    ), /* @__PURE__ */ e.jsx(ne, { ...y(m[6]), row: u.to, children: u.to.CONCEPT_ID }), /* @__PURE__ */ e.jsx(ne, { ...y(m[7]), row: u.to, children: u.to.CONCEPT_CODE }), /* @__PURE__ */ e.jsx(ne, { ...y(m[8]), row: u.to, children: u.to.CONCEPT_NAME }))
                  );
                })
              }
            );
          },
          columns: Fs
        }
      )
    }
  ) });
}, Gs = [
  {
    header: "Non-Standard",
    enableHiding: !1,
    enableSorting: !1,
    id: "non-standard",
    columns: [
      lt("actions"),
      it("conceptId___standard"),
      dt("conceptCode___standard"),
      ut("conceptName___standard")
    ]
  },
  {
    header: "",
    enableHiding: !1,
    id: "actions_header",
    enableResizing: !1,
    enableSorting: !1,
    columns: [fn]
  },
  {
    header: "Standard",
    id: "standard",
    enableHiding: !1,
    enableSorting: !1,
    columns: [
      lt(),
      it("conceptId___non-standard"),
      dt("conceptCode___non-standard"),
      ut("conceptName___non-standard")
    ]
  }
], Hs = ({
  selectedRows: t,
  data: n,
  setSelectedRows: s,
  setActiveRow: a,
  activeRow: c
}) => {
  const d = (r) => {
    const l = r.reduce((i, o) => (i[o.from.id] = !0, i[o.to.CONCEPT_ID] = !0, i), {});
    !Me(l, c) && a(l);
  }, C = (r, l) => {
    const i = { [l.from.id]: !0, [l.to.CONCEPT_ID]: !0 };
    !Me(i, c) && a({ [l.from.id]: !0, [l.to.CONCEPT_ID]: !0 });
  }, h = (r, l, i) => (o, p = !1) => ({
    onMouseOver: () => d(r),
    // onMouseLeave: onHoverOut,
    className: "td",
    rowSpan: i,
    sx: {
      color: c != null && c[l.to.CONCEPT_ID] && !p ? ct.get(xe.STANDARD).color : void 0,
      ...o
    }
  }), E = (r) => (l) => ({
    onMouseOver: (i) => C(i, r),
    // onMouseLeave: onHoverOut,
    className: "td",
    sx: {
      color: c != null && c[r.from.id] && (c != null && c[r.to.CONCEPT_ID]) ? ct.get(xe.NON_STANDARD).color : void 0,
      ...l
    }
  });
  return /* @__PURE__ */ e.jsx(U, { onMouseLeave: () => a(null), children: /* @__PURE__ */ e.jsx(
    gn,
    {
      selectedRows: t,
      setSelectedRows: s,
      children: /* @__PURE__ */ e.jsx(
        je,
        {
          data: n,
          columns: Gs,
          getRowId: (r) => r._id,
          withDuplicates: !0,
          hideSettings: !0,
          customTableRow: ({ data: r, row: l, ...i }) => {
            const o = r.length + 1, p = r.every(
              (u) => t[u._id]
            ), g = r.some(
              (u) => t[u._id]
            ), m = l.getVisibleCells().map((u) => ({
              width: u.column.getCanResize() ? "auto" : u.column.getSize(),
              maxWidth: u.column.getSize(),
              minWidth: u.column.getSize(),
              overflowX: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap"
            }));
            return /* @__PURE__ */ e.jsx(
              U,
              {
                component: "tbody",
                className: "tbody",
                sx: {
                  "&.tbody:hover .tr": {
                    backgroundColor: "#2183d91a"
                  }
                },
                children: r.map((u, R) => {
                  const y = h(r, u, o), P = E(u);
                  return /* @__PURE__ */ sn(U, { ...i, component: "tr", key: u._id }, /* @__PURE__ */ e.jsx(
                    ne,
                    {
                      className: "td",
                      style: { ...m[0], textOverflow: "unset" },
                      children: /* @__PURE__ */ e.jsx(
                        ce,
                        {
                          size: "small",
                          sx: { mt: -0.5 },
                          checked: t[u._id] || !1,
                          onChange: (j, N) => {
                            s((v) => ({
                              ...v,
                              [u._id]: N
                            }));
                          }
                        }
                      )
                    }
                  ), /* @__PURE__ */ e.jsx(ne, { ...P(m[1]), row: u.from, children: u.from.CONCEPT_ID }), /* @__PURE__ */ e.jsx(ne, { ...P(m[2]), row: u.from, children: u.from.CONCEPT_CODE }), /* @__PURE__ */ e.jsx(ne, { ...P(m[3]), row: u.from, children: u.from.CONCEPT_NAME }), R === 0 ? /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
                    /* @__PURE__ */ e.jsx(
                      ne,
                      {
                        ...y(
                          { ...m[4], pointerEvents: "none" },
                          !0
                        ),
                        children: "→"
                      }
                    ),
                    /* @__PURE__ */ e.jsx(
                      ne,
                      {
                        className: "td",
                        rowSpan: o,
                        style: { ...m[5], textOverflow: "unset" },
                        children: /* @__PURE__ */ e.jsx(
                          ce,
                          {
                            size: "small",
                            sx: { mt: -0.5 },
                            checked: p,
                            indeterminate: g && !p,
                            onChange: (j, N) => {
                              s((v) => ({
                                ...v,
                                ...r.reduce((w, f) => (w[f._id] = N, w), {})
                              }));
                            }
                          }
                        )
                      }
                    ),
                    /* @__PURE__ */ e.jsx(ne, { ...y(m[6]), row: u.to, children: u.to.CONCEPT_ID }),
                    /* @__PURE__ */ e.jsx(ne, { ...y(m[7]), row: u.to, children: u.to.CONCEPT_CODE }),
                    /* @__PURE__ */ e.jsx(ne, { ...y(m[8]), row: u.to, children: u.to.CONCEPT_NAME })
                  ] }) : /* @__PURE__ */ e.jsx(e.Fragment, {}));
                })
              }
            );
          }
        }
      )
    }
  ) });
}, Be = /* @__PURE__ */ new Map(), qt = (t) => t || "";
function $s(t, n) {
  const s = Wn("RecordCountsDataSource"), a = qt(t), c = Be.get(a), [d, C] = F((c == null ? void 0 : c.dataSources) || []), [h, E] = F((c == null ? void 0 : c.dataSource) || null), [r, l] = F((c == null ? void 0 : c.status) || S.INITIAL), i = (o) => {
    o ? Kn("RecordCountsDataSource", o) : Yn("RecordCountsDataSource"), n();
  };
  return V(() => {
    let o = !0;
    const p = qt(t), g = Be.get(p);
    if ((g == null ? void 0 : g.status) === S.SUCCESS)
      return C(g.dataSources), E(g.dataSource), l(S.SUCCESS), () => {
        o = !1;
      };
    const m = (g == null ? void 0 : g.promise) || Promise.all([
      Is(),
      t ? Rs(t) : Promise.resolve(null)
    ]).then(([u, R]) => ({
      dataSources: u,
      dataSource: R
    }));
    return Be.set(p, {
      dataSources: (g == null ? void 0 : g.dataSources) || [],
      dataSource: (g == null ? void 0 : g.dataSource) || null,
      status: S.IN_PROGRESS,
      promise: m
    }), l(S.IN_PROGRESS), m.then(({ dataSources: u, dataSource: R }) => {
      Be.set(p, {
        dataSources: u,
        dataSource: R,
        status: S.SUCCESS
      }), o && (C(u), E(R), l(S.SUCCESS));
    }).catch((u) => {
      console.error(u), Be.set(p, {
        dataSources: [],
        dataSource: null,
        status: S.ERROR
      }), o && l(S.ERROR);
    }), () => {
      o = !1;
    };
  }, [t]), { dataSource: h, dataSources: d, status: r, dataSourceId: s, setDataSourceId: i };
}
const Bs = ({ onCookieChange: t, size: n, variant: s = "inline" }) => {
  const a = wt(
    (o) => o.user.data.activeTenant
  ), { dataSource: c, dataSources: d, status: C, dataSourceId: h, setDataSourceId: E } = $s(a, t), r = (d == null ? void 0 : d.find((o) => String(o.id) === String(h))) || c, l = r && !(d != null && d.some((o) => String(o.id) === String(r.id))) ? [r, ...d || []] : d || [], i = l.length ? l.map((o) => ({
    id: String(o.id),
    name: o.name
  })) : C === S.IN_PROGRESS ? [
    {
      id: "",
      name: "Loading data sources...",
      disabled: !0
    }
  ] : [
    {
      id: "",
      name: "No data sources available",
      disabled: !0
    }
  ];
  return s === "compact" ? C === S.ERROR ? null : /* @__PURE__ */ e.jsx(be, { text: "View record counts for data source", arrow: !0, placement: "top", children: /* @__PURE__ */ e.jsx(U, { sx: { display: "inline-block" }, children: /* @__PURE__ */ e.jsx(
    Mn,
    {
      title: /* @__PURE__ */ e.jsx(te, { iconName: "database", sx: { fontSize: 16 } }),
      name: "rc-data-source",
      variant: "text",
      color: "primary",
      closeOnSelect: !0,
      placement: "bottom-start",
      preventOverflow: !0,
      disablePortal: !1,
      options: i,
      sx: (o) => ({
        minWidth: 0,
        px: 1,
        bgcolor: Ft(0.05, o.palette.backgroundColor.light),
        "&:hover": {
          bgcolor: Ft(0.1, o.palette.backgroundColor.dark)
        }
      }),
      onClick: (o) => {
        o != null && o.disabled || E(o.id);
      }
    }
  ) }) }) : /* @__PURE__ */ e.jsxs(
    U,
    {
      width: 300,
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      children: [
        C === S.IN_PROGRESS && /* @__PURE__ */ e.jsx(
          zn,
          {
            width: "100%",
            height: n === "md" ? 30 : 24,
            animation: "wave",
            sx: {
              bgcolor: "secondary.main",
              opacity: 0.4
            }
          }
        ),
        C === S.SUCCESS && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
          /* @__PURE__ */ e.jsx(se, { variant: "subtitle2", children: "View record count for:" }),
          /* @__PURE__ */ e.jsx(
            U,
            {
              flexGrow: 1,
              ml: 1,
              sx: n === "md" ? {
                "&, .autocomplete-input-container": {
                  height: 30
                }
              } : void 0,
              children: /* @__PURE__ */ e.jsx(
                Ue,
                {
                  size: "small",
                  fullWidth: !0,
                  value: r,
                  options: d,
                  name: "rc-data-source",
                  placeholder: "Select Data Source",
                  onChange: function(o, p) {
                    E(p == null ? void 0 : p.id);
                  },
                  isOptionEqualToValue: (o, p) => o.id === p.id,
                  getOptionLabel: function(o) {
                    return (o == null ? void 0 : o.name) || "";
                  },
                  disableClearable: !0
                }
              )
            }
          )
        ] })
      ]
    }
  );
}, Tn = (t, n, s, a, c, d) => {
  const C = [
    {
      header: "Id",
      accessorKey: "conceptId",
      id: "CONCEPT_ID",
      enableColumnFilter: !1,
      size: 100,
      enableHiding: !1
    },
    {
      header: "Code",
      accessorKey: "concept.CONCEPT_CODE",
      id: "CONCEPT_CODE",
      size: 120,
      enableColumnFilter: !1,
      sortingFn: "alphanumeric"
    },
    {
      header: "Name",
      accessorKey: "concept.CONCEPT_NAME",
      id: "CONCEPT_NAME",
      size: 200,
      minSize: 120,
      filterFn: (u, R, y) => {
        var P, j, N;
        return [
          (P = u.original.concept) == null ? void 0 : P.CONCEPT_ID,
          (j = u.original.concept) == null ? void 0 : j.CONCEPT_CODE,
          (N = u.original.concept) == null ? void 0 : N.CONCEPT_NAME
        ].some(
          (v) => String(v).toLowerCase().includes(y[0].toLowerCase())
        );
      },
      sortingFn: "alphanumeric",
      meta: {
        filterVariant: "value"
      }
    },
    {
      header: "Standard Concept",
      accessorFn: (u) => {
        var R;
        return ((R = u.concept) == null ? void 0 : R.STANDARD_CONCEPT) || "N";
      },
      id: "STANDARD_CONCEPT",
      align: "center",
      filterFn: "arrIncludesSomeEqual",
      cell: ({ renderValue: u, row: R }) => {
        if (!R.original.concept) return;
        const { color: y, caption: P } = rt(u());
        return /* @__PURE__ */ e.jsx(
          an,
          {
            text: P,
            color: y,
            align: "center",
            minWidth: 92
          }
        );
      },
      enableResizing: !1,
      meta: {
        filterOrder: 3,
        renderFilter: (u) => rt(u).caption
      }
    },
    {
      header: "Class",
      accessorKey: "concept.CONCEPT_CLASS_ID",
      id: "CONCEPT_CLASS_ID",
      filterFn: "arrIncludesSomeEqual",
      meta: {
        filterHeader: "Concept Class",
        filterOrder: 2
      },
      size: 120
    }
  ], h = [
    {
      header: "Domain",
      accessorKey: "concept.DOMAIN_ID",
      id: "DOMAIN_ID",
      filterFn: "arrIncludesSomeEqual",
      size: 100,
      meta: {
        filterOrder: 1
      }
    },
    {
      header: "Vocabulary",
      accessorKey: "concept.VOCABULARY_ID",
      id: "VOCABULARY_ID",
      filterFn: "arrIncludesSomeEqual",
      size: 120,
      minSize: 80,
      meta: {
        filterOrder: 0
      }
    }
  ], E = [
    {
      header: "Distance",
      accessorKey: "concept.DISTANCE"
    }
  ], r = [
    {
      header: "RC",
      id: "RECORD_COUNT",
      accessorKey: "concept.RECORD_COUNT",
      size: 80,
      cell: ({ getValue: u }) => u() ? tt(u()) : "0",
      filterFn: "greaterThanZero",
      meta: {
        filterVariant: "boolean",
        filterHeader: "Has Record Counts (RC)",
        filterOrder: 5
      }
    },
    {
      header: "DRC",
      id: "DESCENDANT_RECORD_COUNT",
      accessorKey: "concept.DESCENDANT_RECORD_COUNT",
      size: 80,
      cell: ({ getValue: u }) => u() ? tt(u()) : "0",
      filterFn: "greaterThanZero",
      meta: {
        filterVariant: "boolean",
        filterHeader: "Has Descendant Record Counts (DRC)",
        filterOrder: 6
      }
    },
    {
      header: "PC",
      id: "PERSON_COUNT",
      accessorKey: "concept.PERSON_COUNT",
      size: 80,
      cell: ({ getValue: u }) => u() ? tt(u()) : "0",
      filterFn: "greaterThanZero",
      meta: {
        filterVariant: "boolean",
        filterHeader: "Has Person Counts (PC)",
        filterOrder: 7
      }
    },
    {
      header: "DPC",
      id: "DESCENDANT_PERSON_COUNT",
      accessorKey: "concept.DESCENDANT_PERSON_COUNT",
      size: 80,
      cell: ({ getValue: u }) => u() ? tt(u()) : "0",
      filterFn: "greaterThanZero",
      meta: {
        filterVariant: "boolean",
        filterHeader: "Has Descendant Person Counts (DPC)",
        filterOrder: 8
      }
    }
  ], l = [
    st(
      "excluded",
      "Exclude",
      `Marks the concept to be explicitly excluded from the concept Set.
It is possible to exclude a whole sub-trees of concepts by combining Exclude and Descendants/Hierarchy options.
Overrides the implicit inclusion of concepts from Descendants option.`,
      c,
      Vs(d)
    ),
    st(
      "descendants",
      "Descendants",
      `Includes child concepts from the standard hierarchy, utilizing OMOP CDM relation table data.
Option is available only for standard and classification concepts.`,
      c,
      Xt()
    ),
    st(
      "mapped",
      "Mapped",
      `Includes additional non-standard concepts, that this concept has a 'Maps to' relationship with.
If the concept is not mapped to any other concepts with 'Maps to' relationship, it will be excluded from the final list.
Option is available only for standard and classification concepts.`,
      c,
      Xt()
    ),
    st(
      "hierarchy",
      "Hierarchy",
      `Includes child concepts from the native hierarchy of source data, utilizing OMOP CDM relation table data.
Work same way as Descendants, but for non-standard concepts.
Option is available only for non-standard concepts.`,
      c,
      Qs()
    )
  ], i = [
    {
      header: "Invalid Reason",
      accessorKey: "concept.INVALID_REASON_CAPTION",
      id: "INVALID_REASON_CAPTION",
      size: 0,
      enableHiding: !1,
      filterFn: "arrIncludesSomeEqual",
      meta: {
        invisible: !0,
        filterOrder: 4
      }
    }
  ], o = s ? [...r] : [], p = n ? [...E] : [], g = a ? [...l] : [], m = t ? [...h] : [];
  return [
    ...C,
    ...p,
    ...o,
    ...m,
    ...g,
    ...i
  ];
}, st = (t, n, s, a, c, d = 85) => ({
  header: (C) => /* @__PURE__ */ e.jsx(
    Hn,
    {
      ...C,
      title: n,
      disableAllActions: a,
      getDisabledCheckboxCondition: c,
      accessor: t,
      description: s,
      iconMode: !0
    }
  ),
  accessorKey: t,
  size: d,
  enableResizing: !1,
  enableHiding: !1,
  enableSorting: !1,
  enableColumnFilter: !1,
  meta: {
    align: "center",
    headerAlign: "center"
  },
  cell: (C) => {
    var E, r;
    const h = (r = (E = C.row).getIsSelected) == null ? void 0 : r.call(E);
    return /* @__PURE__ */ e.jsx(
      Gn,
      {
        ...C,
        value: C.renderValue(),
        align: "center",
        disabled: C.disabled || !h && a || c(C.row.original)
      }
    );
  }
}), Vs = (t) => (n) => {
  var s;
  return ((s = n.concept) == null ? void 0 : s.CONCEPT_ID) === t;
}, Xt = () => (t) => {
  var n;
  return ((n = t.concept) == null ? void 0 : n.STANDARD_CONCEPT_CAPTION) === xe.NON_STANDARD_CAPTION;
}, Qs = () => (t) => {
  var n, s;
  return ((n = t.concept) == null ? void 0 : n.STANDARD_CONCEPT_CAPTION) === xe.STANDARD_CAPTION || ((s = t.concept) == null ? void 0 : s.STANDARD_CONCEPT_CAPTION) === xe.CLASSIFICATION_CAPTION;
}, Ws = Q(Se)`
  ${({ hasHeaderInfo: t }) => t ? `
    .collapsible-content-block__title {
      align-items: center;
      line-height: normal;
      min-height: 46px;
      padding-top: 6px;
      padding-bottom: 6px;
    }

    .collapsible-content-block__title-text {
      min-width: 0;
      padding-right: 16px;
      font-weight: 400;
      overflow: hidden;

      > span {
        display: block;
        min-width: 0;
      }
    }

    .collapsible-content-block__actions {
      flex: 0 0 auto;
      align-self: center;
    }
  ` : ""}
`, In = Q.div`
  display: flex;
  align-items: center;
  gap: 8px;
  max-width: 980px;
  min-width: 0;
  color: ${({ theme: t }) => {
  var n;
  return ((n = t.palette.textColor) == null ? void 0 : n.main) || "#1d2d4d";
}};
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;

  svg {
    width: 16px;
    height: 16px;
    flex: 0 0 16px;
  }

  span {
    display: block;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`, ft = {
  xs: "250px",
  lg: "280px",
  xl: "300px"
};
function pe(t) {
  var b, M;
  const {
    hasDomainAndVocabulary: n = !0,
    hasDistance: s = !1,
    hasRcDrc: a = !0,
    hasRcDrcSelect: c = !1,
    hasHierarchy: d = !0,
    disableEdit: C = !0,
    currentConceptSetId: h,
    hasDraftConceptModal: E = !1,
    title: r = "All Concepts",
    headerInfo: l,
    status: i,
    noDataText: o = "No data currently available",
    collapsible: p = !1,
    outlined: g = !1,
    noGaps: m = !1,
    storageKey: u,
    hasFilters: R,
    wrapColumns: y = (k) => k
  } = t, P = wt(
    (k) => k.user.data
  ), j = t.storage ?? pn(
    `${P.activeTenant}${u || "concepts-table"}`,
    t.hiddenColumns ?? {
      shortcut: !0,
      "created.timestamp": !0
    }
  ), N = W(() => {
    var H;
    return ((H = t.data) == null ? void 0 : H.map(
      (Y) => {
        var Z;
        return ((Z = t.selectedConcepts) == null ? void 0 : Z[Y.id]) || Y;
      }
    )) || [];
  }, [t.data, t.selectedConcepts]), v = t.selectedConcepts ? Object.keys(t.selectedConcepts).reduce((k, H) => (k[H] = !0, k), {}) : {}, w = W(
    () => y(
      Tn(
        n,
        s,
        a,
        d,
        C,
        h
      )
    ),
    [
      n,
      s,
      a,
      d,
      C,
      h
    ]
  ), f = t.onSelectAll ? async (k, H) => {
    t.variant === "controlled" && t.onSelectAll && (H ? await t.fetchData(0, t.totalElements, null, !0).then(t.onSelectAll) : t.onSelectAll({}));
  } : void 0, I = t.variant == "uncontrolled" ? t.reloadData : t.fetchData;
  return /* @__PURE__ */ e.jsx(
    Ws,
    {
      collapsible: p,
      outlined: g,
      noGaps: m,
      defaultState: !p,
      hasHeaderInfo: !!l,
      actions: /* @__PURE__ */ e.jsx(
        U,
        {
          display: "flex",
          minHeight: 42,
          alignItems: "center",
          sx: {
            "> *:not(:first-of-type)": {
              ml: 1
            }
          },
          children: t.customActions
        }
      ),
      title: l || /* @__PURE__ */ e.jsx(
        Fe,
        {
          title: r,
          count: t.variant !== "uncontrolled" ? t.totalElements : N.length,
          loading: i === S.IN_PROGRESS || i === S.IN_PROGRESS_RELOAD
        }
      ),
      children: /* @__PURE__ */ e.jsx(x, { container: !0, spacing: 4, flexWrap: "nowrap", children: /* @__PURE__ */ e.jsx(
        x,
        {
          item: !0,
          flexGrow: 1,
          sx: {
            width: {
              xs: `calc(100% - ${ft.xs})`,
              lg: `calc(100% - ${ft.lg})`,
              xl: `calc(100% - ${ft.xl})`
            },
            ...E ? { mb: 5 } : { borderRadius: 1 }
          },
          children: /* @__PURE__ */ e.jsx(
            je,
            {
              variant: t.variant || "controlled",
              data: N,
              columns: w,
              pageSize: Number(t.pageSize) || null,
              pageIndex: Number(t.pageIndex) || null,
              defaultSorting: (b = j.storage) == null ? void 0 : b.sort,
              onRowSelect: t.onRowSelect,
              getRowId: t.getRowId || ((k) => String(k.id)),
              loadingMessage: "Loading concepts table...",
              enableRowSelection: t.enableRowSelection,
              onEdit: t.onEdit,
              onSelectAll: f,
              setPagination: t.setPagination,
              selectedRowIds: v,
              onRowClick: t.onRowClick,
              loading: i === S.IN_PROGRESS || i === S.IN_PROGRESS_RELOAD,
              isInitial: i === S.INITIAL,
              noDataText: o,
              columnVisibility: (M = j.storage) == null ? void 0 : M.columns,
              pinnedColumns: {
                left: ["select", "CONCEPT_ID", "CONCEPT_CODE", "CONCEPT_NAME"]
              },
              persistSettings: j.setStorage,
              showFilterToggle: t.showFilterToggle,
              tableOptionsActions: /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
                c && !!I && /* @__PURE__ */ e.jsx(
                  Bs,
                  {
                    onCookieChange: I,
                    variant: "compact"
                  }
                ),
                t.tableOptionsActions
              ] }),
              children: t.children,
              ...t.variant !== "uncontrolled" && {
                totalElements: t.totalElements,
                pageCount: Number(t.pageCount),
                fetchData: t.fetchData,
                hasFilters: R,
                searchComponent: t.searchComponent
              },
              ...t.variant !== "controlled" && {
                enableFiltering: t.enableFiltering
              },
              selectedElements: t.selectedConcepts,
              disabled: t.disabled,
              filtersDefaultClosed: t.filtersDefaultClosed
            }
          )
        }
      ) })
    }
  );
}
const Ys = (t, n) => {
  const s = {};
  return t.map((a) => ({ ...a.to, from: a.from })).forEach((a) => {
    let c = we(a);
    s[c.conceptId] ? s[c.conceptId].from.push(a.from) : (c.action = n[a.CONCEPT_ID] ? "add" : "default", c.id = Dt(), c.from = [a.from], s[c.conceptId] = c);
  }), s;
}, Ks = (t, n, s) => (a) => [
  {
    header: "",
    accessorKey: "conceptId",
    id: "actions",
    size: t ? 134 : 40,
    enableResizing: !1,
    meta: {
      columnType: "action"
    },
    cell: ({ getValue: c, row: d }) => /* @__PURE__ */ e.jsx(U, { display: "flex", alignItems: "center", mx: -0.5, children: n[c()] ? /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
      /* @__PURE__ */ e.jsx(
        be,
        {
          text: "This concept is already present in concept set. Please choose action",
          children: /* @__PURE__ */ e.jsx(
            U,
            {
              sx: {
                bgcolor: "#ffac3342",
                borderRadius: "4px",
                width: 24,
                height: 24,
                display: "flex",
                alignContent: "center",
                alignItems: "center",
                p: "2px",
                boxSizing: "border-box",
                mr: 1
              },
              children: /* @__PURE__ */ e.jsx(
                te,
                {
                  iconName: "warning",
                  color: "warning",
                  sx: {
                    top: -1,
                    position: "relative",
                    fontSize: 20
                  }
                }
              )
            }
          )
        }
      ),
      /* @__PURE__ */ e.jsx(U, { minWidth: "86px", children: /* @__PURE__ */ e.jsx(
        rn,
        {
          size: "small",
          options: [
            { value: "replace", name: "Replace" },
            { value: "add", name: "Add" }
          ],
          value: d.original.action,
          onChange: (C) => {
            s((h) => ({
              ...h,
              [d.original.conceptId]: {
                ...d.original,
                action: C
              }
            }));
          },
          fullWidth: !0
        }
      ) })
    ] }) : /* @__PURE__ */ e.jsx(
      U,
      {
        sx: {
          bgcolor: "#aed88342",
          borderRadius: "4px",
          width: 24,
          height: 24,
          display: "flex",
          alignContent: "center",
          alignItems: "center",
          p: "2px",
          boxSizing: "border-box",
          mr: 1
        },
        children: /* @__PURE__ */ e.jsx(
          te,
          {
            iconName: "check",
            color: "success",
            sx: { left: -2, position: "relative" }
          }
        )
      }
    ) })
  },
  ...a.filter((c) => c.header !== "Class")
], qs = ({
  selectedConcepts: t,
  onClose: n,
  items: s,
  onUpdate: a
}) => {
  const c = Ve(Object.values(s), "conceptId"), [d, C] = F(
    Ys(t, c)
  ), h = () => {
    const r = {}, l = {};
    Object.values(d).forEach((i) => {
      switch (i.action) {
        case "add":
          r[i.id] = i, i.from.forEach((o) => {
            l[o.id] = o;
          }), delete r[i.id].action, delete r[i.id].from;
          break;
        case "replace":
          r[i.id] = i, i.from.forEach((o) => {
            l[o.id] = o;
          }), c[i.conceptId] && c[i.conceptId].forEach((o) => {
            l[o.id] = !0;
          }), delete r[i.id].action, delete r[i.id].from;
          break;
        case "default":
          r[i.id] = i, i.from.forEach((o) => {
            l[o.id] = o;
          }), delete r[i.id].action, delete r[i.id].from;
          break;
      }
    }), a({ updated: r, deleted: l });
  }, E = Object.values(d).some(
    (r) => c[r.conceptId]
  );
  return /* @__PURE__ */ e.jsxs(
    x,
    {
      container: !0,
      flexDirection: "column",
      position: "relative",
      pb: "60px",
      display: "flex",
      width: "inherit",
      children: [
        /* @__PURE__ */ e.jsx(
          x,
          {
            item: !0,
            xs: 12,
            bgcolor: "white",
            sx: (r) => ({ boxShadow: r.customShadows[3] }),
            p: 2,
            children: /* @__PURE__ */ e.jsx(se, { variant: "h1", children: "Concept set preview" })
          }
        ),
        /* @__PURE__ */ e.jsx(x, { item: !0, xs: 12, p: 2, children: /* @__PURE__ */ e.jsxs(We, { outlined: !0, elevated: !0, children: [
          Object.values(d).some(
            (r) => {
              var l;
              return ((l = c[r.conceptId]) == null ? void 0 : l.length) > 0;
            }
          ) && /* @__PURE__ */ e.jsx(U, { p: 2, children: /* @__PURE__ */ e.jsxs(Ct, { severity: "warning", children: [
            "Some of the mapped ",
            /* @__PURE__ */ e.jsx("b", { children: "standard concepts are already present" }),
            " ",
            "in the concept set. There may be multiple occurrences. You can choose to either ",
            /* @__PURE__ */ e.jsx("b", { children: "Add" }),
            " a new concept record to the concept set and address the conflicts later, or ",
            /* @__PURE__ */ e.jsx("b", { children: "Replace" }),
            " all existing occurrences now."
          ] }) }),
          /* @__PURE__ */ e.jsx(
            pe,
            {
              disableEdit: !1,
              wrapColumns: Ks(
                E,
                c,
                C
              ),
              data: Object.values(d),
              variant: "uncontrolled",
              status: S.SUCCESS,
              onEdit: (r) => {
                C((l) => ({
                  ...l,
                  ...(Array.isArray(r) ? r : [r]).reduce((i, o) => (i[o.row.conceptId] = {
                    ...o.row,
                    [o.columnId]: o.value
                  }, i), {})
                }));
              }
            }
          )
        ] }) }),
        /* @__PURE__ */ e.jsxs(x, { item: !0, position: "fixed", bottom: 0, right: 0, width: "inherit", children: [
          /* @__PURE__ */ e.jsx(qe, {}),
          /* @__PURE__ */ e.jsxs(
            U,
            {
              bgcolor: "white",
              px: 2,
              py: 1,
              justifyContent: "flex-end",
              display: "flex",
              sx: {
                "*:not(:last-of-type)": {
                  mr: 1
                }
              },
              children: [
                /* @__PURE__ */ e.jsx(
                  ge,
                  {
                    onClick: n,
                    color: "info",
                    title: "Cancel",
                    iconName: "close",
                    noCollapse: !0
                  }
                ),
                /* @__PURE__ */ e.jsx(
                  ht,
                  {
                    onClick: h,
                    color: "success",
                    title: "Apply",
                    iconName: "submit",
                    noCollapse: !0
                  }
                )
              ]
            }
          )
        ] })
      ]
    }
  );
}, Xs = (t) => {
  var y, P;
  const { items: n, onUpdate: s } = t, [a, c] = F({}), [d, C] = F(null), [h, E] = F(!1), r = $(async () => {
    const N = dn(n).filter((w) => {
      if (w.STANDARD_CONCEPT !== "S" && w.STANDARD_CONCEPT !== "C")
        return !0;
    }), v = N.map(
      (w) => w.CONCEPT_ID
    );
    return vs(v).then((w) => {
      const f = [];
      for (let I of w)
        for (let b of I.MAPPED_FROM) {
          const M = N.find(
            (k) => k.CONCEPT_ID === b
          );
          f.push({
            from: M,
            to: I,
            _id: I.CONCEPT_ID + "_" + M.id
          });
        }
      return f;
    });
  }, [n]), { state: l, status: i } = jt(r), o = $((j, N) => {
    let v = [];
    const w = {};
    if (N != null && N.length && (N.forEach((f) => {
      const I = f.from.id;
      w[I] = w[I] ? w[I] + 1 : 1;
    }), N))
      switch (j) {
        case "all":
          v = N;
          break;
        case "one-to-one":
          v = N.filter(
            (f) => {
              var I, b;
              return ((b = (I = f.to) == null ? void 0 : I.MAPPED_FROM) == null ? void 0 : b.length) === 1 && w[f.from.id] === 1;
            }
          );
          break;
        case "n-to-one":
          v = N.filter(
            (f) => {
              var I, b;
              return ((b = (I = f.to) == null ? void 0 : I.MAPPED_FROM) == null ? void 0 : b.length) > 1;
            }
          );
          break;
        case "one-to-n":
          v = N.filter(
            (f) => w[f.from.id] > 1
          );
          break;
      }
    return v;
  }, []), p = W(
    () => Object.values(Ve(o("all", l), "from.id")),
    [l]
  ), g = W(
    () => Ne(o("one-to-one", l), "_id"),
    [l]
  ), m = W(
    () => Object.values(Ve(o("one-to-one", l), "_id")),
    [l]
  ), u = W(
    () => Object.values(Ve(o("one-to-n", l), "from.id")),
    [l]
  ), R = W(
    () => Object.values(
      Ve(o("n-to-one", l), "to.CONCEPT_ID")
    ),
    [l]
  );
  return i === S.IN_PROGRESS ? /* @__PURE__ */ e.jsx(U, { textAlign: "center", pt: "20%", children: /* @__PURE__ */ e.jsx(Et, { size: 60, color: "secondary" }) }) : (p == null ? void 0 : p.length) === 0 ? /* @__PURE__ */ e.jsx(x, { container: !0, p: 2, children: /* @__PURE__ */ e.jsx(Se, { elevated: !0, outlined: !0, children: /* @__PURE__ */ e.jsx(Ct, { severity: "info", children: "No suggestions found." }) }) }) : /* @__PURE__ */ e.jsxs(
    x,
    {
      container: !0,
      position: "relative",
      minHeight: "calc(100% - 64px)",
      pb: "60px",
      flexDirection: "column",
      display: "flex",
      width: "inherit",
      children: [
        /* @__PURE__ */ e.jsx(x, { item: !0, p: 2, flexGrow: 1, width: "100%", children: /* @__PURE__ */ e.jsxs(x, { container: !0, spacing: 2, children: [
          /* @__PURE__ */ e.jsx(x, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
            Se,
            {
              title: /* @__PURE__ */ e.jsx(Fe, { title: "All", count: (p == null ? void 0 : p.length) || 0 }),
              actions: /* @__PURE__ */ e.jsx(
                ge,
                {
                  onClick: (j) => {
                    j.stopPropagation(), c(g);
                  },
                  color: "info",
                  title: "Select all one to one mappings",
                  iconName: "submit",
                  noCollapse: !0,
                  disabled: (p == null ? void 0 : p.length) === 0
                }
              ),
              outlined: !0,
              elevated: !0,
              size: "dense",
              collapsible: !!(p != null && p.length),
              defaultState: (p == null ? void 0 : p.length) > 0,
              children: /* @__PURE__ */ e.jsx(
                gt,
                {
                  selectedRows: a,
                  setSelectedRows: c,
                  data: p,
                  setActiveRow: C,
                  activeRow: d
                }
              )
            }
          ) }),
          /* @__PURE__ */ e.jsx(x, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
            Se,
            {
              title: /* @__PURE__ */ e.jsx(
                Fe,
                {
                  title: "One-To-One",
                  count: (m == null ? void 0 : m.length) || 0
                }
              ),
              outlined: !0,
              elevated: !0,
              size: "dense",
              collapsible: !!(m != null && m.length),
              defaultState: !1,
              children: /* @__PURE__ */ e.jsx(
                gt,
                {
                  selectedRows: a,
                  setSelectedRows: c,
                  data: m,
                  setActiveRow: C,
                  activeRow: d
                }
              )
            }
          ) }),
          /* @__PURE__ */ e.jsx(x, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
            Se,
            {
              title: /* @__PURE__ */ e.jsx(
                Fe,
                {
                  title: "One-To-Many",
                  count: (u == null ? void 0 : u.length) || 0
                }
              ),
              outlined: !0,
              elevated: !0,
              size: "dense",
              collapsible: !!(u != null && u.length),
              defaultState: !1,
              children: /* @__PURE__ */ e.jsx(
                gt,
                {
                  selectedRows: a,
                  setSelectedRows: c,
                  data: u,
                  setActiveRow: C,
                  activeRow: d
                }
              )
            }
          ) }),
          /* @__PURE__ */ e.jsx(x, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
            Se,
            {
              title: /* @__PURE__ */ e.jsx(
                Fe,
                {
                  title: "Many-To-One",
                  count: ((y = R.flat()) == null ? void 0 : y.length) || 0
                }
              ),
              outlined: !0,
              elevated: !0,
              size: "dense",
              defaultState: !1,
              collapsible: !!(R != null && R.length),
              children: /* @__PURE__ */ e.jsx(
                Hs,
                {
                  selectedRows: a,
                  setSelectedRows: c,
                  data: R,
                  setActiveRow: C,
                  activeRow: d
                }
              )
            }
          ) })
        ] }) }),
        /* @__PURE__ */ e.jsxs(x, { item: !0, position: "fixed", bottom: 0, right: 0, width: "inherit", children: [
          /* @__PURE__ */ e.jsx(qe, {}),
          /* @__PURE__ */ e.jsx(U, { bgcolor: "white", px: 2, py: 1, textAlign: "right", children: /* @__PURE__ */ e.jsx(
            ht,
            {
              onClick: () => E(!0),
              color: "success",
              title: "Apply changes",
              iconName: "submit",
              noCollapse: !0,
              disabled: ((P = Object.keys(a)) == null ? void 0 : P.length) === 0
            }
          ) })
        ] }),
        /* @__PURE__ */ e.jsx(
          Ye,
          {
            open: h,
            onClose: function() {
              E(!1);
            },
            children: /* @__PURE__ */ e.jsx(
              qs,
              {
                items: n,
                selectedConcepts: (l == null ? void 0 : l.filter((j) => a[j._id])) || [],
                onUpdate: s,
                onClose: function() {
                  E(!1);
                }
              }
            )
          }
        )
      ]
    }
  );
}, Zs = {
  status: S.INITIAL,
  typeContainer: De.WORKSPACE,
  conceptSet: null,
  parentId: null,
  error: null
}, Js = (t, n) => ve(
  t,
  (s) => {
    switch (n.type) {
      case "CREATE_CONCEPT_SET":
        s.status = S.IN_PROGRESS;
        break;
      case "CREATE_CONCEPT_SET_DONE":
        s.conceptSet = n.payload, s.status = S.SUCCESS;
        break;
    }
  }
), eo = (t, n) => {
  switch (t) {
    case De.WORKSPACE:
      return (s) => ws(s);
    case De.STUDY:
      return (s) => ks(n, s);
  }
}, to = (t) => {
  const { enqueueSnackbar: n } = St(), [s, a] = Pe(Js, Zs), c = $(
    async ({ name: d, parentId: C, typeContainer: h }) => {
      a({
        type: "CREATE_CONCEPT_SET"
        /* CREATE_CONCEPT_SET */
      });
      try {
        const r = await eo(h, C)({
          name: d,
          items: t
        });
        a({
          type: "CREATE_CONCEPT_SET_DONE",
          payload: r
        }), n({
          message: `Concept Set "${r.name}" was successfully created`
        });
      } catch {
        n({
          message: "Something went wrong",
          variant: "error"
        });
      }
    },
    [s]
  );
  return {
    ...s,
    createNewConceptSet: c
  };
}, no = ({
  onClose: t,
  onCancel: n,
  subModules: s,
  concepts: a
}) => {
  var g;
  const [c, d] = F(""), [C, h] = F(
    De.WORKSPACE
  ), [E, r] = F(""), { status: l, createNewConceptSet: i } = to(
    qn(a)
  ), o = ((g = c.trim()) == null ? void 0 : g.length) === 0 || C === De.STUDY && !E, p = (m) => {
    i({
      name: c,
      parentId: E,
      typeContainer: C
    }), t();
  };
  return /* @__PURE__ */ e.jsxs(x, { container: !0, justifyContent: "flex-end", spacing: 1, children: [
    /* @__PURE__ */ e.jsxs(x, { item: !0, display: "flex", width: 180, pr: 2, children: [
      /* @__PURE__ */ e.jsxs(
        se,
        {
          variant: "subtitle1",
          component: "label",
          sx: {
            mr: 1,
            whiteSpace: "nowrap",
            sup: {
              color: "error.main",
              ml: 0.25
            }
          },
          children: [
            "Add to",
            /* @__PURE__ */ e.jsx("sup", { children: "*" })
          ]
        }
      ),
      /* @__PURE__ */ e.jsx(
        rn,
        {
          className: "",
          name: "typeContainer",
          disablePortal: !0,
          id: "typeContainer",
          options: ts.filter((m) => m.value !== "ATLAS"),
          value: C,
          placeholder: "Select type",
          onChange: (m) => {
            h(m);
          },
          fullWidth: !0
        }
      )
    ] }),
    C === De.STUDY && /* @__PURE__ */ e.jsxs(x, { item: !0, display: "flex", maxWidth: 300, width: "50%", pr: 2, children: [
      /* @__PURE__ */ e.jsxs(
        se,
        {
          variant: "subtitle1",
          component: "label",
          sx: {
            mr: 1,
            sup: {
              color: "error.main",
              ml: 0.25
            }
          },
          children: [
            "Study",
            /* @__PURE__ */ e.jsx("sup", { children: "*" })
          ]
        }
      ),
      /* @__PURE__ */ e.jsx(x, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
        s.study,
        {
          type: "component",
          name: "user-studies-list",
          subModules: s,
          config: {
            onChange: (m) => {
              r((m == null ? void 0 : m.id) || "");
            },
            studyInitialId: null
          }
        }
      ) })
    ] }),
    /* @__PURE__ */ e.jsxs(x, { item: !0, flexGrow: 1, children: [
      /* @__PURE__ */ e.jsxs(
        se,
        {
          variant: "subtitle1",
          component: "label",
          sx: {
            mr: 1,
            sup: {
              color: "error.main",
              ml: 0.25
            }
          },
          children: [
            "Name",
            /* @__PURE__ */ e.jsx("sup", { children: "*" })
          ]
        }
      ),
      /* @__PURE__ */ e.jsx(
        bt,
        {
          value: c,
          onChange: (m) => d(m.target.value),
          placeholder: "Enter concept set name...",
          sx: { minWidth: 200, width: "30%" }
        }
      )
    ] }),
    /* @__PURE__ */ e.jsx(x, { item: !0, children: /* @__PURE__ */ e.jsx(
      ht,
      {
        onClick: p,
        color: "success",
        iconName: "submit",
        title: "Create",
        disabled: o || l === S.IN_PROGRESS,
        tooltipText: o ? "Fill out missing information" : "",
        loading: l === S.IN_PROGRESS
      }
    ) }),
    /* @__PURE__ */ e.jsx(x, { item: !0, children: /* @__PURE__ */ e.jsx(
      ge,
      {
        onClick: function(m) {
          d(""), r(""), h(De.WORKSPACE), n();
        },
        iconName: "close",
        title: "Cancel",
        color: "error"
      }
    ) })
  ] });
}, so = (t) => {
  const { onOverwriteConceptSet: n, items: s } = t, [a] = F(dn(s)), { enqueueSnackbar: c } = St(), d = $(() => Ps(a).then((u) => (l(
    Ne(
      Mt(u.optimizedConceptSet),
      "id"
    )
  ), u)), [a]), { state: C, status: h } = jt(d), {
    selectedConcepts: E,
    updateSelectedConceptBulk: r,
    init: l
  } = _e({}, "id"), [i, o] = F(!1), p = () => {
    o((u) => !u);
  }, g = (u) => {
    r(Array.isArray(u) ? u : [u]);
  }, m = () => {
    try {
      n(E), c({
        message: "Overwriting completed successfully",
        variant: "success"
      }), t.onClose();
    } catch (u) {
      console.error("OWERWRITING FAILED", u), c({
        message: "Something went wrong",
        variant: "error"
      });
    }
  };
  if (h === S.IN_PROGRESS)
    return /* @__PURE__ */ e.jsx(At, { children: /* @__PURE__ */ e.jsx(Et, { size: 32 }) });
  if ((C == null ? void 0 : C.optimizedConceptSet.length) === a.length)
    return /* @__PURE__ */ e.jsx(x, { container: !0, p: 2, children: /* @__PURE__ */ e.jsx(Se, { elevated: !0, outlined: !0, children: /* @__PURE__ */ e.jsx(Ct, { severity: "info", children: "Current concept set definition is fully optimized." }) }) });
  if (C && C.optimizedConceptSet.length !== a.length)
    return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
      /* @__PURE__ */ e.jsx(Se, { children: /* @__PURE__ */ e.jsx(x, { item: !0, xs: 12, justifyContent: "flex-end", display: "flex", children: i ? /* @__PURE__ */ e.jsx(
        no,
        {
          onClose: t.onClose,
          onCancel: p,
          subModules: t.subModules,
          concepts: Object.values(E)
        }
      ) : /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
        /* @__PURE__ */ e.jsx(
          oe,
          {
            onClick: p,
            name: "createNewConceptSet",
            variant: "outlined",
            startIcon: /* @__PURE__ */ e.jsx(te, { iconName: "add" }),
            children: "Create new concept set"
          }
        ),
        /* @__PURE__ */ e.jsx(
          oe,
          {
            onClick: m,
            name: "overwriteConceptSet",
            variant: "contained",
            color: "success",
            startIcon: /* @__PURE__ */ e.jsx(te, { iconName: "submit" }),
            sx: { ml: 1 },
            children: "Overwrite current concept set"
          }
        )
      ] }) }) }),
      /* @__PURE__ */ e.jsxs(x, { container: !0, spacing: 2, p: 2, children: [
        /* @__PURE__ */ e.jsx(x, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(We, { elevated: !0, outlined: !0, children: /* @__PURE__ */ e.jsx(
          pe,
          {
            variant: "uncontrolled",
            title: "Optimized concepts",
            disableEdit: !0,
            filtersDefaultClosed: !0,
            hasDomainAndVocabulary: !0,
            data: Object.values(E),
            status: h,
            noDataText: "No data currently available",
            selectedConcepts: {},
            onEdit: g,
            hiddenColumns: {
              RECORD_COUNT: !1,
              DESCENDANT_RECORD_COUNT: !1,
              PERSON_COUNT: !1,
              DESCENDANT_PERSON_COUNT: !1,
              CONCEPT_CLASS_ID: !1
            }
          }
        ) }) }),
        /* @__PURE__ */ e.jsx(x, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(We, { elevated: !0, outlined: !0, children: /* @__PURE__ */ e.jsx(
          pe,
          {
            variant: "uncontrolled",
            hiddenColumns: {
              RECORD_COUNT: !1,
              DESCENDANT_RECORD_COUNT: !1,
              PERSON_COUNT: !1,
              DESCENDANT_PERSON_COUNT: !1,
              CONCEPT_CLASS_ID: !1
            },
            title: "Removed concepts",
            disableEdit: !0,
            filtersDefaultClosed: !0,
            hasDomainAndVocabulary: !0,
            data: C != null && C.removedConceptSet ? Mt(
              C == null ? void 0 : C.removedConceptSet
            ) : [],
            selectedConcepts: {},
            status: h,
            noDataText: "No data currently available"
          }
        ) }) })
      ] })
    ] });
}, oo = Q(x)(
  ({ theme: t }) => ({
    // backgroundColor: theme.palette.backgroundColor.main,
    // borderRadius: theme.shape.borderRadius + 'px',
    alignItems: "center"
  })
), ao = Q.div`
  margin-left: 8px;
  background-color: ${({ theme: t }) => {
  var n;
  return ((n = t.palette) == null ? void 0 : n.info.main) + "20";
}};
  color: ${({ theme: t }) => {
  var n;
  return (n = t.palette) == null ? void 0 : n.textColor.primary;
}};
  border-radius: 2px;
  font-weight: 400;
  padding: 2px 8px;
  height: 16px;
  font-size: 12px;
  line-height: 16px;
  text-decoration: none;
`;
Q(Se)`
  border: none;
  box-shadow: none;
  margin-bottom: 0;
  > div {
    // padding: 15px 0;
  }
  .collapsible-content-block__title {
    font-size: 14px;
  }
`;
Q.label`
  display: flex;
  align-items: center;
`;
const ro = Q.section`
  display: flex;
  align-items: center;
  .search-button,
  .reset-button {
    margin-left: 12px;
    min-width: auto;
  }
`;
Q.section``;
const Rn = Te((t) => {
  const { onFind: n, initialQuery: s, onClear: a, dense: c, isInitial: d } = t, [C, h] = F(() => s || ""), [E, r] = F(!1), l = (o) => {
    o.preventDefault(), C != null && (h(""), n("", E));
  }, i = fe.useCallback(
    (o) => {
      o.preventDefault(), n(C, E);
    },
    [C, E]
  );
  return fe.useEffect(() => {
    h(s);
  }, [s]), /* @__PURE__ */ e.jsx(x, { container: !0, children: /* @__PURE__ */ e.jsx(x, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx("form", { onSubmit: i, className: "search-form", action: "", children: /* @__PURE__ */ e.jsxs(ro, { children: [
    /* @__PURE__ */ e.jsx(
      bt,
      {
        fullWidth: !0,
        placeholder: "Search...",
        size: "large",
        value: C,
        onChange: (o) => h(o.target.value),
        type: "text",
        name: "search-input",
        InputProps: {
          endAdornment: /* @__PURE__ */ e.jsx(It, { size: "small", onClick: l, children: /* @__PURE__ */ e.jsx(be, { text: "Clear", children: /* @__PURE__ */ e.jsx(te, { iconName: "close", sx: { fontSize: 14 } }) }) })
        }
      }
    ),
    /* @__PURE__ */ e.jsx(
      oe,
      {
        color: "success",
        variant: "contained",
        type: "submit",
        name: "submitSearch",
        size: "large",
        sx: c ? { minWidth: 0 } : {},
        className: "search-button",
        startIcon: c ? void 0 : /* @__PURE__ */ e.jsx(
          te,
          {
            iconName: "search",
            sx: { "&.MuiSvgIcon-root": { fontSize: 18 } }
          }
        ),
        children: c ? /* @__PURE__ */ e.jsx(
          te,
          {
            iconName: "search",
            sx: { "&.MuiSvgIcon-root": { fontSize: 18 } }
          }
        ) : "Search"
      }
    ),
    /* @__PURE__ */ e.jsx(
      oe,
      {
        color: "info",
        variant: "text",
        name: "resetAll",
        size: "small",
        className: "reset-button",
        onClick: (o) => {
          l(o), a == null || a();
        },
        sx: {
          ".start-icon-small svg": { fontSize: 12 },
          whiteSpace: "nowrap",
          ml: 2,
          px: 2,
          fontWeight: 400,
          visibility: d ? "hidden" : "visible"
        },
        startIcon: /* @__PURE__ */ e.jsx(te, { iconName: "close" }),
        children: "Reset all"
      }
    ),
    /* @__PURE__ */ e.jsxs(
      x,
      {
        item: !0,
        display: "flex",
        pr: 2,
        onClick: (o) => {
          o.stopPropagation();
        },
        children: [
          /* @__PURE__ */ e.jsx(x, { item: !0, px: 1, children: /* @__PURE__ */ e.jsx(
            cn,
            {
              id: "advanced-search-syntax",
              value: E,
              checked: E,
              onChange: (o) => {
                r((p) => !p);
              },
              size: "small",
              color: "info"
            }
          ) }),
          /* @__PURE__ */ e.jsx(
            U,
            {
              component: "label",
              htmlFor: "advanced-search-syntax",
              sx: [
                E ? {} : { opacity: 0.3 },
                { width: 200, color: "primary.main" }
              ],
              children: "Advanced search syntax"
            }
          )
        ]
      }
    )
  ] }) }) }) });
}), co = {
  "filter.invalid.reason": ["Valid"],
  "filter.standard.concept": ["Standard"],
  "filter.domain": []
}, lo = ({ title: t = "", description: n = "" }) => /* @__PURE__ */ e.jsxs(x, { item: !0, xs: 12, mt: 2, container: !0, flexWrap: "nowrap", alignItems: "center", children: [
  /* @__PURE__ */ e.jsx(x, { item: !0, pr: 2, children: /* @__PURE__ */ e.jsx(x, { item: !0, xs: 12, textAlign: "center", mb: 1, children: /* @__PURE__ */ e.jsx(Pt, {}) }) }),
  /* @__PURE__ */ e.jsxs(x, { item: !0, flexGrow: 1, children: [
    t && /* @__PURE__ */ e.jsx(x, { item: !0, xs: 12, mb: 2, children: /* @__PURE__ */ e.jsx(se, { variant: "h3", children: t }) }),
    /* @__PURE__ */ e.jsx(x, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(se, { variant: "body2", children: n }) })
  ] })
] }), io = ({ onUpdate: t, hasDraftConceptModal: n }) => {
  var E, r;
  const { domains: s, status: a, error: c } = Vn(), [d, C] = F(co), h = (l, i) => {
    C((o) => ({ ...o, [l]: i || [] }));
  };
  return V(() => {
    t(
      Object.entries(d).reduce((l, [i, o]) => (i === "filter.domain" ? l[i] = o.map((p) => p.DOMAIN_ID) : l[i] = o, l), {})
    );
  }, [d]), /* @__PURE__ */ e.jsx(x, { item: !0, xs: 12, p: n ? 0 : 2, children: /* @__PURE__ */ e.jsx(ye, { elevation: 0, children: /* @__PURE__ */ e.jsxs(x, { item: !0, xs: 12, p: n ? 0 : 2, children: [
    /* @__PURE__ */ e.jsxs(x, { container: !0, spacing: 3, mb: 2, children: [
      /* @__PURE__ */ e.jsx(x, { item: !0, flexBasis: 300, children: /* @__PURE__ */ e.jsx(
        Ue,
        {
          fullWidth: !0,
          multiple: !0,
          id: "filter.domain",
          name: "filter.domain",
          placeholder: "Select Domains...",
          value: d["filter.domain"] || [],
          loading: a === S.IN_PROGRESS,
          options: s,
          onChange: (l, i) => {
            h("filter.domain", i);
          },
          getOptionLabel: function(l) {
            return l.DOMAIN_NAME;
          },
          isOptionEqualToValue: (l, i) => l.DOMAIN_ID === i.DOMAIN_ID,
          renderTags: () => {
            var l;
            return /* @__PURE__ */ e.jsx(
              on,
              {
                size: "small",
                label: ((l = d["filter.domain"]) == null ? void 0 : l.length) + " selected",
                sx: {
                  borderRadius: 0.5,
                  mx: 0.5,
                  height: 22,
                  fontSize: 12,
                  color: "textColor.primary"
                }
              }
            );
          }
        }
      ) }),
      /* @__PURE__ */ e.jsxs(x, { item: !0, display: "flex", alignItems: "center", children: [
        /* @__PURE__ */ e.jsx(
          ce,
          {
            size: "small",
            id: "filter.standard.concept",
            name: "filter.standard.concept",
            checked: ((E = d == null ? void 0 : d["filter.standard.concept"]) == null ? void 0 : E[0]) === "Standard",
            onChange: (l) => {
              const { name: i, checked: o } = l.target;
              h(i, o ? ["Standard"] : null);
            },
            sx: { mr: 1 }
          }
        ),
        /* @__PURE__ */ e.jsx(
          se,
          {
            component: "label",
            htmlFor: "filter.standard.concept",
            fontSize: 14,
            children: "Standard only"
          }
        )
      ] }),
      /* @__PURE__ */ e.jsxs(x, { item: !0, display: "flex", alignItems: "center", children: [
        /* @__PURE__ */ e.jsx(
          ce,
          {
            size: "small",
            id: "filter.invalid.reason",
            checked: ((r = d == null ? void 0 : d["filter.invalid.reason"]) == null ? void 0 : r[0]) === "Valid",
            name: "filter.invalid.reason",
            onChange: (l) => {
              const { name: i, checked: o } = l.target;
              h(i, o ? ["Valid"] : null);
            },
            sx: { mr: 1 }
          }
        ),
        /* @__PURE__ */ e.jsx(
          se,
          {
            component: "label",
            htmlFor: "filter.invalid.reason",
            fontSize: 14,
            children: "Valid only"
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ e.jsx(qe, { sx: { borderColor: "borderColor.light" } }),
    /* @__PURE__ */ e.jsx(x, { item: !0, mt: 2, children: /* @__PURE__ */ e.jsx(
      lo,
      {
        title: "",
        description: /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
          /* @__PURE__ */ e.jsx("b", { children: "OMOP Vocabularies" }),
          " store information about",
          " ",
          /* @__PURE__ */ e.jsx("b", { children: "Concepts" }),
          " which describe miscellaneous clinical events, such as demographics, visits, conditions, procedures, drugs, measurements, and more. One or more concepts can be assembled into a ",
          /* @__PURE__ */ e.jsx("b", { children: "Concept Set" }),
          " to specify a broader definition that can be used as a part of the cohort inclusion criteria definitions or as a part of the analysis design."
        ] })
      }
    ) })
  ] }) }) });
}, On = ({
  draftSelectedConceptsCount: t,
  openSelectedArea: n,
  vocabularyMode: s,
  onSubmitAction: a,
  onRowClickAction: c,
  showOutlet: d = !0,
  replaceSearchParams: C = !1
}) => {
  const [h, E] = fe.useState(!0), [r, l] = cs(), i = wt(
    (G) => G.user.data
  ), { state: o, status: p } = jt(Ts), g = pn(`${i.activeTenant}search`, {
    shortcut: !0,
    "created.timestamp": !0
  }), m = t != null, {
    search: u,
    filters: R,
    searchData: y,
    searchParams: { advancedSearch: P, searchFilters: j, searchQuery: N, pageNumber: v },
    pageCount: w,
    pageSize: f,
    totalElements: I,
    status: b,
    updateQuery: M,
    updateFilters: k,
    updateSearchParams: H,
    resetFilters: Y,
    updateAdvancedSearch: Z
  } = kt(null, null, null, g == null ? void 0 : g.storage), {
    selectedConcepts: le,
    detectSelectedAction: ae,
    clear: K,
    init: re,
    updateSelectedConceptBulk: T
  } = _e(), _ = (G) => {
    const L = Xn({
      ...zt(r),
      ...G
    });
    l(L, { replace: C });
  }, O = () => {
    Y(), l({}, { replace: C }), E(!0);
  }, A = (G, L) => {
    E(!1), _({
      fullSearch: G,
      advancedSearch: L
    }), M(G), Z(L);
  }, D = () => {
    a == null || a(le), K();
  }, z = () => {
    K();
  }, ie = ({ original: G }) => {
    c == null || c(G);
  }, Ce = (G) => {
    _({
      pageNumber: G.pageIndex
    });
  }, q = (G) => {
    T(Array.isArray(G) ? G : [G]);
  }, he = $((G, L) => {
    const J = Ie(G);
    ae(J, L);
  }, []), Re = W(() => {
    const G = { ...j };
    return delete G.fullSearch, Object.values(G).some((L) => (L == null ? void 0 : L.length) > 0);
  }, [j]), { otherFilters: ke } = Je(
    R,
    "fullSearch"
  );
  return fe.useEffect(() => {
    var L;
    const G = zt(r);
    h && ((L = Object.values(G)) != null && L.length) && (H(G), E(!1));
  }, [r]), /* @__PURE__ */ e.jsxs(
    x,
    {
      container: !0,
      flexDirection: "column",
      flexWrap: "nowrap",
      minHeight: "inherit",
      children: [
        /* @__PURE__ */ e.jsxs(x, { item: !0, xs: 12, children: [
          m && /* @__PURE__ */ e.jsx(
            ns,
            {
              title: "Vocabulary",
              iconName: "vocabulary",
              customButtons: /* @__PURE__ */ e.jsxs(
                oe,
                {
                  onClick: n,
                  name: "open-draft-concept-set",
                  size: "large",
                  color: "info",
                  sx: {
                    span: {
                      fontWeight: "400",
                      textDecoration: "underline"
                    }
                  },
                  children: [
                    /* @__PURE__ */ e.jsx("span", { children: "Draft concept set" }),
                    /* @__PURE__ */ e.jsx(ao, { className: "chip", children: t })
                  ]
                }
              )
            }
          ),
          /* @__PURE__ */ e.jsx(
            oo,
            {
              container: !0,
              item: !0,
              xs: 12,
              py: m ? 2 : 0,
              className: "search-query-container",
              children: /* @__PURE__ */ e.jsx(x, { item: !0, xs: 9, children: /* @__PURE__ */ e.jsx(
                Rn,
                {
                  initialQuery: N,
                  onFind: (G, L) => A(G, L),
                  onClear: O,
                  isInitial: h
                }
              ) })
            }
          ),
          h ? /* @__PURE__ */ e.jsx(
            io,
            {
              onUpdate: (G) => {
                k(G);
              },
              hasDraftConceptModal: m
            }
          ) : /* @__PURE__ */ e.jsxs(x, { item: !0, xs: 12, p: s ? 0 : 2, pb: 0, children: [
            /* @__PURE__ */ e.jsx(
              vt,
              {
                onAdd: D,
                onClear: z,
                selectedConceptsCount: Object.keys(le).length,
                buttonText: s ? "Add to draft concept set " : "Add to concept set ",
                width: t != null ? "calc(100% - 70px)" : window.innerWidth - 250 + "px"
              }
            ),
            /* @__PURE__ */ e.jsx(
              pe,
              {
                variant: "controlled",
                pageCount: w,
                pageIndex: v,
                pageSize: f,
                totalElements: I,
                data: y,
                getRowId: (G) => String(G.conceptId),
                selectedConcepts: le,
                onRowSelect: he,
                onEdit: q,
                onRowClick: ie,
                setPagination: Ce,
                fetchData: u,
                onSelectAll: re,
                status: b,
                storage: g,
                hasRcDrcSelect: !0,
                hasDraftConceptModal: !0,
                enableRowSelection: !0,
                noGaps: s,
                showFilterToggle: !0,
                hasFilters: Re,
                children: /* @__PURE__ */ e.jsx(
                  Xe,
                  {
                    showLabel: !0,
                    filters: ke,
                    value: j,
                    onChange: (G, L) => {
                      const J = { [G]: L };
                      _(J), k(J), g == null || g.setStorage("filters", {
                        ...j,
                        ...J
                      });
                    },
                    isLoading: b === S.IN_PROGRESS,
                    isReloading: b === S.IN_PROGRESS_RELOAD
                  }
                )
              }
            )
          ] })
        ] }),
        /* @__PURE__ */ e.jsx(
          x,
          {
            item: !0,
            xs: 12,
            sx: {
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "flex-end",
              mb: 1
            },
            children: /* @__PURE__ */ e.jsx(se, { variant: "subtitle2", px: 2, color: "primary.light", children: "Vocabulary version: " + o })
          }
        ),
        d && /* @__PURE__ */ e.jsx(ls, {})
      ]
    }
  );
};
function bn(t, n = "conceptId") {
  const [s, a] = F(S.INITIAL), [c, d] = F({}), C = async (h) => {
    if (s !== S.IN_PROGRESS) {
      a(S.IN_PROGRESS);
      try {
        const E = await xn(
          Object.values(h).map((l) => l.conceptId)
        ).catch((l) => (console.error("LOAD CONCEPT LIST ERROR:", l), [])), r = Ne(
          Object.values(h).map((l, i) => ({
            ...l,
            concept: {
              ...l.concept,
              ...E[i]
            }
          })),
          n
        );
        return a(S.SUCCESS), d(Object.values(r)), r;
      } catch (E) {
        console.error(E), a(S.ERROR);
      }
    }
  };
  return V(() => {
    Object.keys(t || {}).length > 0 ? C(t) : Object.keys(t || {}).length === 0 && d({});
  }, [t]), {
    status: s,
    concepts: c,
    loadConceptsData: C
  };
}
const uo = (t) => {
  const {
    concepts: n,
    onClose: s,
    onChange: a,
    onChangeBulk: c,
    subModules: d,
    pureClose: C,
    path: h
  } = t, E = Ge(), { status: r, concepts: l, loadConceptsData: i } = bn(n), { selectedConcepts: o, detectSelectedAction: p, clear: g } = _e({}, "conceptId"), m = !Object.keys(o).length, u = !Object.keys(n).length, R = (N) => {
    a(Array.isArray(N) ? N : [N]);
  }, y = () => {
    const N = Object.values(n).reduce((v, w) => (o[w.conceptId] || (v[w.conceptId] = w), v), {});
    c(N), g();
  }, P = $((N, v) => {
    const w = Ie(N);
    p(w, v);
  }, []), j = () => {
    s == null || s();
  };
  return /* @__PURE__ */ e.jsx(x, { container: !0, children: /* @__PURE__ */ e.jsxs(x, { item: !0, xs: 12, children: [
    /* @__PURE__ */ e.jsx(Nt, { onClose: C, children: "Draft concept set" }),
    /* @__PURE__ */ e.jsx(ye, { elevation: 3, children: /* @__PURE__ */ e.jsx(
      d.concept,
      {
        type: "component",
        name: "widget-concept-set-save",
        path: "/concept-sets",
        subModules: d,
        config: {
          concepts: l,
          onSave: j,
          disableActions: u
        }
      }
    ) }),
    /* @__PURE__ */ e.jsx(x, { container: !0, children: /* @__PURE__ */ e.jsx(x, { item: !0, xs: 12, p: 2, children: /* @__PURE__ */ e.jsx(We, { elevated: !0, outlined: !0, children: /* @__PURE__ */ e.jsx(x, { container: !0, children: /* @__PURE__ */ e.jsx(x, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
      pe,
      {
        storageKey: "concept-set-draft",
        showFilterToggle: !0,
        disableEdit: !1,
        data: Object.values(l),
        enableRowSelection: !0,
        getRowId: (N) => String(N.conceptId),
        onRowSelect: P,
        onEdit: R,
        onRowClick: (N) => {
          E(
            `/${h}/modal/related/${N.original.conceptId}`,
            {
              state: {
                closeTo: `/${h}/modal/selected`
              }
            }
          );
        },
        pageIndex: 0,
        selectedConcepts: o,
        title: "Selected concepts",
        status: r,
        reloadData: () => {
          i(n);
        },
        hasRcDrc: !0,
        variant: "uncontrolled",
        enableFiltering: !0,
        hasRcDrcSelect: !0,
        customActions: /* @__PURE__ */ e.jsx(e.Fragment, { children: /* @__PURE__ */ e.jsxs(
          oe,
          {
            variant: "outlined",
            disabled: m,
            onClick: y,
            startIcon: /* @__PURE__ */ e.jsx(te, { iconName: "delete", sx: { fontSize: 16 } }),
            name: "delete-selected",
            color: "error",
            sx: { ml: 1, alignItems: "center" },
            children: [
              "Delete selected (",
              Object.keys(o).length || 0,
              ")"
            ]
          }
        ) }),
        filtersDefaultClosed: !0
      }
    ) }) }) }) }) })
  ] }) });
}, po = (t) => {
  const {
    id: n,
    onClickConcept: s,
    onChangeConcept: a,
    onSelectConcept: c,
    selectedConcepts: d,
    filtersAncestors: C,
    relatedAncestors: h,
    isNativeHierarchy: E,
    viewMode: r
  } = t, { data: l, form: i, setFilters: o, resetFilters: p, updateFilters: g, status: m } = C, {
    concepts: u,
    pageCount: R,
    totalElements: y,
    numberOfElements: P,
    getRelated: j,
    status: N
  } = h;
  V(() => (o(
    ms(n, E),
    Ze
  ), () => {
    p();
  }), []);
  const v = (b) => {
    a(Array.isArray(b) ? b : [b]);
  }, w = Object.values(i).some(
    (b) => (b == null ? void 0 : b.length) > 0
  ), { otherFilters: f, searchFilter: I } = Je(
    l,
    "fullSearch"
  );
  return /* @__PURE__ */ e.jsx(
    pe,
    {
      variant: "controlled",
      storageKey: "concept-ancestors",
      disableEdit: !0,
      showFilterToggle: !0,
      hasHierarchy: !r,
      enableRowSelection: !r,
      title: "Ancestors",
      pageCount: R,
      totalElements: y,
      data: u,
      getRowId: (b) => String(b.conceptId),
      selectedConcepts: d,
      onRowSelect: c,
      onEdit: v,
      onRowClick: s,
      onSelectAll: (b) => c(Object.values(b), b),
      fetchData: j,
      status: N,
      hasRcDrcSelect: !0,
      collapsible: !0,
      outlined: !0,
      pageIndex: 0,
      noDataText: w ? "The result listing is empty because of the filter you applied" : "No data currently available",
      hasFilters: w,
      searchComponent: I && /* @__PURE__ */ e.jsx(
        mt,
        {
          ...I,
          value: i == null ? void 0 : i[I == null ? void 0 : I.name],
          onChange: (b) => g(I == null ? void 0 : I.name, b)
        }
      ),
      children: /* @__PURE__ */ e.jsx(
        Xe,
        {
          showLabel: !0,
          filters: f,
          value: i,
          onChange: g,
          isReloading: m === S.IN_PROGRESS_RELOAD || N === S.IN_PROGRESS_RELOAD,
          isLoading: m === S.IN_PROGRESS || N === S.IN_PROGRESS || N === S.INITIAL
        }
      )
    }
  );
}, Co = (t) => {
  const {
    id: n,
    onClickConcept: s,
    onChangeConcept: a,
    onSelectConcept: c,
    selectedConcepts: d,
    filtersDescendants: C,
    relatedDescendants: h,
    isNativeHierarchy: E,
    viewMode: r
  } = t, { data: l, form: i, setFilters: o, resetFilters: p, updateFilters: g, status: m } = C, {
    concepts: u,
    pageCount: R,
    totalElements: y,
    numberOfElements: P,
    getRelated: j,
    status: N
  } = h;
  V(() => (o(
    xs(n, E),
    Ze
  ), () => {
    p();
  }), []);
  const v = (b) => {
    a(Array.isArray(b) ? b : [b]);
  }, w = Object.values(i).some(
    (b) => (b == null ? void 0 : b.length) > 0
  ), { otherFilters: f, searchFilter: I } = Je(
    l,
    "fullSearch"
  );
  return /* @__PURE__ */ e.jsx(fe.Fragment, { children: /* @__PURE__ */ e.jsx(
    pe,
    {
      variant: "controlled",
      storageKey: "concept-descendants",
      disableEdit: !0,
      showFilterToggle: !0,
      hasHierarchy: !r,
      enableRowSelection: !r,
      title: "Descendants",
      pageCount: R,
      totalElements: y,
      data: u,
      getRowId: (b) => String(b.conceptId),
      selectedConcepts: d,
      onRowSelect: c,
      onEdit: v,
      onRowClick: s,
      onSelectAll: (b) => c(Object.values(b), b),
      fetchData: j,
      status: N,
      hasRcDrcSelect: !0,
      pageIndex: 0,
      collapsible: !0,
      outlined: !0,
      noDataText: w ? "The result listing is empty because of the filter you applied" : "No data currently available",
      hasFilters: w,
      searchComponent: I && /* @__PURE__ */ e.jsx(
        mt,
        {
          ...I,
          value: i == null ? void 0 : i[I == null ? void 0 : I.name],
          onChange: (b) => g(I == null ? void 0 : I.name, b)
        }
      ),
      children: /* @__PURE__ */ e.jsx(
        Xe,
        {
          showLabel: !0,
          filters: f,
          value: i,
          onChange: g,
          isReloading: m === S.IN_PROGRESS_RELOAD || N === S.IN_PROGRESS_RELOAD,
          isLoading: m === S.IN_PROGRESS || N === S.IN_PROGRESS || N === S.INITIAL
        }
      )
    }
  ) });
}, ho = {
  relatedIds: {
    data: [],
    status: S.INITIAL
  },
  relatedConceptsPageData: {
    rawData: [],
    data: [],
    status: S.INITIAL
  },
  filters: {
    data: [],
    form: {},
    status: S.INITIAL
  },
  status: S.INITIAL,
  pageCount: 0,
  totalElements: 0,
  numberOfElements: 0,
  sortBy: void 0
};
function Eo(t, n) {
  return ve(t, (s) => {
    var a, c;
    switch (n.type) {
      case "GET_RELATED_IDS": {
        s.relatedIds.status = s.relatedIds.status === S.INITIAL ? S.IN_PROGRESS : S.IN_PROGRESS_RELOAD, s.status = s.status === S.INITIAL ? S.IN_PROGRESS : S.IN_PROGRESS_RELOAD, s.filters.status = s.filters.status === S.INITIAL ? S.IN_PROGRESS : S.IN_PROGRESS_RELOAD;
        break;
      }
      case "GET_RELATED_IDS_SUCCESS": {
        s.relatedIds.status = S.SUCCESS, s.relatedIds.data = n.payload.concepts, s.totalElements = ((a = n.payload.concepts) == null ? void 0 : a.length) || 0, s.sortBy = ((c = n.payload) == null ? void 0 : c.sortBy) || void 0;
        break;
      }
      case "GET_FILTERS_SUCCESS": {
        s.filters.data = n.payload.filters, s.filters.status = S.SUCCESS;
        break;
      }
      case "GET_RELATED_IDS_ERROR": {
        s.relatedIds.status = S.ERROR;
        break;
      }
      case "GET_RELATED_CONCEPTS": {
        s.relatedConceptsPageData.status = S.IN_PROGRESS, s.status = s.status === S.INITIAL ? S.IN_PROGRESS : S.IN_PROGRESS_RELOAD;
        break;
      }
      case "GET_RELATED_CONCEPTS_SUCCESS": {
        s.relatedConceptsPageData.data = n.payload.data, s.relatedConceptsPageData.rawData = n.payload.rawData, s.pageCount = Math.ceil(
          t.totalElements / n.payload.pageSize
        ), s.relatedConceptsPageData.status = S.SUCCESS, s.status = S.SUCCESS;
        break;
      }
      case "GET_RELATED_CONCEPTS_ERROR": {
        s.relatedConceptsPageData.status = S.ERROR, s.status = S.ERROR;
        break;
      }
      case "UPDATE_FILTERS": {
        const { key: d, value: C } = n.payload;
        s.filters.form[d] = C;
        break;
      }
    }
  });
}
function So(t) {
  const [n, s] = Pe(
    Eo,
    ho
  ), a = (C, h) => {
    s({
      type: "UPDATE_FILTERS",
      payload: { key: C, value: h }
    });
  }, c = $(
    async (C) => {
      if (t != null) {
        s({
          type: "GET_RELATED_IDS"
          /* GET_RELATED_IDS */
        });
        try {
          const h = xt(n.filters.form);
          gs(t, h, C).then((E) => {
            s({
              type: "GET_RELATED_IDS_SUCCESS",
              payload: { concepts: E, sortBy: C }
            });
          }), fs(t)(h).then(Ze).then((E) => {
            s({
              type: "GET_FILTERS_SUCCESS",
              payload: { filters: E }
            });
          });
        } catch (h) {
          console.error(h);
        }
      }
    },
    [t, n.filters.form]
  ), d = $(
    async (C = 0, h = 10, E, r = !1) => {
      const l = async (i) => {
        const o = await xn(i);
        return { data: o.map(
          (g) => we(g)
        ), rawData: o };
      };
      if (r) {
        const i = n.relatedIds.data.map((p) => p.id), { data: o } = await l(i);
        return Ne(o, "conceptId");
      } else if (Me(E, n.sortBy)) {
        if (n.relatedIds.status === S.SUCCESS) {
          s({
            type: "GET_RELATED_CONCEPTS"
            /* GET_RELATED_CONCEPTS */
          });
          try {
            const o = n.relatedIds.data.slice(C * h, C * h + h).map((m) => m.id), { data: p, rawData: g } = await l(o);
            s({
              type: "GET_RELATED_CONCEPTS_SUCCESS",
              payload: {
                rawData: g,
                data: p,
                pageSize: h,
                pageNumber: C
              }
            });
          } catch (o) {
            console.error(o);
          }
        }
      } else
        c(E);
    },
    [n.relatedIds.data]
  );
  return V(() => {
    c();
  }, [c]), { ...n, getRelatedConcepts: d, updateFilters: a };
}
const mo = (t) => {
  var o;
  const {
    id: n,
    onClickConcept: s,
    onChangeConcept: a,
    onSelectConcept: c,
    selectedConcepts: d,
    viewMode: C
  } = t, h = So(n), E = (p) => {
    a(Array.isArray(p) ? p : [p]);
  }, r = Object.values(h.filters.form).some(
    (p) => (p == null ? void 0 : p.length) > 0
  ), { otherFilters: l, searchFilter: i } = Je(
    h.filters.data
  );
  return /* @__PURE__ */ e.jsx(
    pe,
    {
      variant: "controlled",
      storageKey: "concept-related",
      disableEdit: !0,
      showFilterToggle: !0,
      hasHierarchy: !C,
      enableRowSelection: !C,
      pageCount: h.pageCount,
      totalElements: h.totalElements,
      data: h.relatedConceptsPageData.data,
      getRowId: (p) => String(p.conceptId),
      selectedConcepts: d,
      onRowSelect: c,
      onEdit: E,
      onSelectAll: (p) => c(Object.values(p), p),
      onRowClick: s,
      fetchData: h.getRelatedConcepts,
      status: h.status,
      hasRcDrcSelect: !0,
      pageIndex: 0,
      outlined: !0,
      hasFilters: r,
      searchComponent: i && /* @__PURE__ */ e.jsx(
        mt,
        {
          ...i,
          value: (o = h.filters.form) == null ? void 0 : o[i == null ? void 0 : i.name],
          onChange: (p) => h.updateFilters(i == null ? void 0 : i.name, p)
        }
      ),
      children: /* @__PURE__ */ e.jsx(
        Xe,
        {
          showLabel: !0,
          filters: l,
          value: h.filters.form,
          onChange: h.updateFilters,
          isReloading: h.filters.status === S.IN_PROGRESS_RELOAD,
          isLoading: h.filters.status === S.IN_PROGRESS || h.filters.status === S.INITIAL
        }
      )
    }
  );
}, xo = {
  selectedConcepts: {},
  objectConcepts: {},
  status: S.INITIAL,
  updateStatus: S.INITIAL
};
var B = /* @__PURE__ */ ((t) => (t.INIT_CONCEPT_PROGRESS = "INIT_CONCEPT_PROGRESS", t.REINITIAL_CONCEPTS = "REINITIAL_CONCEPTS", t.SET_INITIAL_STATE = "SET_INITIAL_STATE", t.ADD_SELECTED_CONCEPT = "ADD_SELECTED_CONCEPT", t.REMOVE_SELECTED_CONCEPT = "REMOVE_SELECTED_CONCEPT", t.UPDATE_CONCEPT = "UPDATE_CONCEPT", t.UPDATE_CONCEPT_BULK = "UPDATE_CONCEPT_BULK", t.UPDATE_CONCEPT_PROGRESS = "UPDATE_CONCEPT_PROGRESS", t.REMOVE_CONCEPT_PROGRESS = "REMOVE_CONCEPT_PROGRESS", t.CREATE_CONCEPT_PROGRESS = "CREATE_CONCEPT_PROGRESS", t.REMOVE_CONCEPT = "REMOVE_CONCEPT", t.CREATE_CONCEPT = "CREATE_CONCEPT", t.LOAD_CONCEPTS = "LOAD_CONCEPTS", t.LOAD_CONCEPTS_SUCCESS = "LOAD_CONCEPTS_SUCCESS", t.LOAD_CONCEPTS_ERROR = "LOAD_CONCEPTS_ERROR", t.OVERWRITE_CONCEPT_SET_PROGRESS = "OVERWRITE_CONCEPT_SET_PROGRESS", t.OVERWRITE_CONCEPT_SET = "OVERWRITE_CONCEPT_SET", t))(B || {});
const _o = (t, n) => ve(
  t,
  (s) => {
    switch (n.type) {
      case B.CREATE_CONCEPT_PROGRESS:
        s.status = S.IN_PROGRESS;
        break;
      case B.CREATE_CONCEPT:
        s.objectConcepts = {
          ...n.payload.concepts,
          ...s.objectConcepts
        }, s.status = S.SUCCESS;
        break;
      case B.UPDATE_CONCEPT_PROGRESS:
        s.updateStatus = S.IN_PROGRESS;
        break;
      case B.UPDATE_CONCEPT:
        s.objectConcepts[n.payload.concept.id] = n.payload.concept, s.updateStatus = S.SUCCESS;
        break;
      case B.UPDATE_CONCEPT_BULK:
        for (const a of n.payload) {
          const c = a.id ?? Dt();
          s.objectConcepts[c] = { ...a, id: c };
        }
        s.updateStatus = S.SUCCESS;
        break;
      case B.REINITIAL_CONCEPTS:
        s.objectConcepts = n.payload;
        break;
      case B.REMOVE_CONCEPT_PROGRESS:
        s.status = S.IN_PROGRESS;
        break;
      case B.REMOVE_CONCEPT:
        Object.keys(n.payload).forEach((a) => {
          delete s.objectConcepts[a];
        }), s.selectedConcepts = {}, s.status = S.SUCCESS;
        break;
      case B.REMOVE_SELECTED_CONCEPT:
        delete s.selectedConcepts[n.payload.id], s.status = S.SUCCESS;
        break;
      case B.LOAD_CONCEPTS:
        s.status = S.IN_PROGRESS;
        break;
      case B.LOAD_CONCEPTS_SUCCESS:
        s.objectConcepts = n.payload, s.status = S.SUCCESS;
        break;
      case B.OVERWRITE_CONCEPT_SET_PROGRESS:
        s.status = S.IN_PROGRESS;
        break;
      case B.OVERWRITE_CONCEPT_SET:
        s.objectConcepts = n.payload, s.status = S.SUCCESS;
        break;
    }
  }
), go = (t, n = "embedded") => {
  const [s, a] = Pe(
    _o,
    {
      ...xo,
      objectConcepts: t,
      status: n === "stand-alone" ? S.SUCCESS : S.INITIAL
    }
  ), { status: c, loadConceptsData: d } = bn(), C = $(
    async (p) => {
      a({ type: B.CREATE_CONCEPT_PROGRESS }), a({
        type: B.CREATE_CONCEPT,
        payload: {
          concepts: Rt(p)
        }
      });
    },
    []
  ), h = $((p) => {
    a({
      type: B.UPDATE_CONCEPT_PROGRESS
    }), setTimeout(() => {
      a({
        type: B.UPDATE_CONCEPT,
        payload: {
          concept: {
            ...p,
            //  we should probably start working with CONCEPT_ID s instead of generating random
            id: p.id
          }
          // id: concept.id ?? getUUID(),
        }
      });
    }, 100);
  }, []), E = (p) => {
    a({
      type: B.REINITIAL_CONCEPTS,
      payload: p
    });
  }, r = (p) => {
    a({
      type: B.UPDATE_CONCEPT_PROGRESS
    }), setTimeout(() => {
      a({
        type: B.UPDATE_CONCEPT_BULK,
        payload: p
      });
    }, 100);
  }, l = $((p) => {
    a({
      type: B.REMOVE_CONCEPT_PROGRESS
    }), setTimeout(() => {
      a({
        type: B.REMOVE_CONCEPT,
        payload: p
      });
    }, 300);
  }, []), i = async (p = t) => {
    a({ type: B.LOAD_CONCEPTS });
    try {
      const g = await d(p);
      a({
        type: B.LOAD_CONCEPTS_SUCCESS,
        payload: Rt(g)
      });
    } catch (g) {
      console.error(g);
    }
  }, o = (p) => {
    a({
      type: B.OVERWRITE_CONCEPT_SET_PROGRESS
    }), setTimeout(() => {
      a({
        type: B.OVERWRITE_CONCEPT_SET,
        payload: Ne(p, "id")
      });
    }, 100);
  };
  return V(() => {
    n === "embedded" && s.status === S.INITIAL && i(t);
  }, [t, n]), {
    ...s,
    loadStatus: c,
    createConcepts: C,
    updateConcept: h,
    removeConcepts: l,
    updateConceptsBulk: r,
    reloadConceptData: i,
    reinitialConcepts: E,
    overwriteConceptSet: o
  };
};
var Oe = /* @__PURE__ */ ((t) => (t.GET_CONCEPTS_REQUEST = "GET_CONCEPTS_REQUEST", t.GET_CONCEPTS_REQUEST_DONE = "GET_CONCEPTS_REQUEST_DONE", t.GET_CONCEPTS_REQUEST_FAILED = "GET_CONCEPTS_REQUEST_FAILED", t.SET_FILTERS_QUERY = "SET_FILTERS_QUERY", t))(Oe || {});
const fo = (t, n) => ve(t, (s) => {
  switch (n.type) {
    case Oe.GET_CONCEPTS_REQUEST:
      s.status = s.status === S.INITIAL ? S.IN_PROGRESS : S.IN_PROGRESS_RELOAD;
      break;
    case Oe.GET_CONCEPTS_REQUEST_DONE:
      s.concepts = n.payload.content, s.pageCount = n.payload.totalPages || 1, s.totalElements = n.payload.totalElements, s.numberOfElements = n.payload.numberOfElements, s.status = S.SUCCESS;
      break;
    case Oe.SET_FILTERS_QUERY:
      s.filtersQuery = n.payload;
      break;
  }
}), To = {
  concepts: [],
  error: null,
  pageCount: 1,
  totalElements: 0,
  numberOfElements: 0,
  filtersQuery: "",
  status: S.INITIAL
}, Zt = (t, n, s, a) => {
  const [c, d] = Pe(
    fo,
    To
  ), C = $(
    async (E = 0, r = 10, l, i = !1) => {
      i || d({
        type: Oe.GET_CONCEPTS_REQUEST
      });
      try {
        const o = await Es(n, s, t, {
          pageNumber: E,
          pageSize: r,
          sortBy: l,
          query: c.filtersQuery
        }), p = o.content.map(
          (m) => we(m)
        );
        if (i)
          return Ne(p, "conceptId");
        const g = {
          ...o,
          content: p
        };
        d({
          type: Oe.GET_CONCEPTS_REQUEST_DONE,
          payload: g
        });
      } catch (o) {
        d({
          type: Oe.GET_CONCEPTS_REQUEST_FAILED,
          payload: o
        });
      }
    },
    [t, c.filtersQuery]
  ), h = $((E) => {
    E && d({
      type: Oe.SET_FILTERS_QUERY,
      payload: xt(E)
    });
  }, []);
  return V(() => {
    h(a);
  }, [a]), V(() => {
    C();
  }, []), {
    ...c,
    setFiltersQuery: h,
    getRelated: C
  };
};
var ue = /* @__PURE__ */ ((t) => (t.SEARCH_REQUEST = "SEARCH_REQUEST", t.SEARCH_REQUEST_DONE = "SEARCH_REQUEST_DONE", t.UPDATE_FILTERS = "UPDATE_FILTERS", t.RESET_FILTERS = "RESET_FILTERS", t.FILTERS_REQUEST = "FILTERS_REQUEST", t.FILTERS_REQUEST_DONE = "FILTERS_REQUEST_DONE", t))(ue || {});
const Io = (t, n) => ve(t, (s) => {
  switch (n.type) {
    case ue.SEARCH_REQUEST:
      s.status = s.status === S.INITIAL ? S.IN_PROGRESS : S.IN_PROGRESS_RELOAD;
      break;
    case ue.SEARCH_REQUEST_DONE:
      s.includedItems = n.payload.data.content, s.pageCount = n.payload.data.totalPages || 1, s.pageNumber = n.payload.data.number || 0, s.numberOfElements = n.payload.data.numberOfElements, s.totalElements = n.payload.data.totalElements, s.status = S.SUCCESS;
      break;
    case ue.FILTERS_REQUEST:
      s.filtersStatus = s.filtersStatus === S.INITIAL ? S.IN_PROGRESS : S.IN_PROGRESS_RELOAD;
      break;
    case ue.FILTERS_REQUEST_DONE:
      s.filters = n.payload.filters, s.filtersStatus = S.SUCCESS;
      break;
    case ue.UPDATE_FILTERS:
      s.filtersForm = { ...s.filtersForm, ...n.payload };
      break;
    case ue.RESET_FILTERS:
      s.filtersForm = [];
      break;
  }
}), Ro = {
  searchQuery: "",
  pageCount: 1,
  pageNumber: 0,
  pageSize: 10,
  numberOfElements: 0,
  totalElements: 0,
  includedItems: [],
  status: S.INITIAL,
  filters: [],
  filtersForm: {},
  filtersStatus: S.INITIAL
}, Oo = (t, n) => {
  const [s, a] = Pe(
    Io,
    Ro
  ), c = (h) => {
    a({
      type: ue.UPDATE_FILTERS,
      payload: h
    });
  }, d = () => {
    a({
      type: ue.RESET_FILTERS
    });
  }, C = $(
    async (h = s.pageNumber, E = s.pageSize, r, l = !1) => {
      if (l || (a({ type: ue.SEARCH_REQUEST }), a({ type: ue.FILTERS_REQUEST })), {
        fullSearch: [s.searchQuery, `${s.searchQuery}*`]
      })
        try {
          const o = {
            query: xt(s.filtersForm),
            pageNumber: h,
            pageSize: E,
            sortBy: r
          }, p = t.get(o, n).then((g) => {
            let m = [];
            g && (m = g.content.map(
              (R) => we(R)
            ));
            const u = {
              ...g,
              content: m
            };
            if (l)
              return Ne(m, "conceptId");
            a({
              type: ue.SEARCH_REQUEST_DONE,
              payload: { data: u }
            });
          });
          if (l)
            return await p;
          t.getFilters(o, n).then((g) => {
            a({
              type: ue.FILTERS_REQUEST_DONE,
              payload: {
                filters: g ? Ze(g) : []
              }
            });
          });
        } catch (o) {
          console.error(o);
        }
    },
    [s.searchQuery, s.filtersForm]
  );
  return {
    ...s,
    fetchIncluded: C,
    updateFilters: c,
    resetFilters: d
  };
};
var de = /* @__PURE__ */ ((t) => (t.UPDATE_IDENTIFIERS = "UPDATE_IDENTIFIERS", t.UPDATE_SOURCE_CODES = "UPDATE_SOURCE_CODES", t.ADD_CONCEPTS_BY_IDENTIFIERS_REQUEST = "ADD_CONCEPTS_BY_IDENTIFIERS_REQUEST", t.ADD_CONCEPTS_BY_SOURCE_CODES_REQUEST = "ADD_CONCEPTS_BY_SOURCE_CODES_REQUEST", t.ADD_CONCEPTS_BY_IDENTIFIERS_REQUEST_DONE = "ADD_CONCEPTS_BY_IDENTIFIERS_REQUEST_DONE", t.ADD_CONCEPTS_BY_SOURCE_CODES_REQUEST_DONE = "ADD_CONCEPTS_BY_SOURCE_CODES_REQUEST_DONE", t.SWITCH_CHECK_MODE = "SWITCH_CHECK_MODE", t))(de || {});
const bo = (t, n) => ve(t, (s) => {
  switch (n.type) {
    case de.UPDATE_IDENTIFIERS:
      s.identifiers = n.payload;
      break;
    case de.UPDATE_SOURCE_CODES:
      s.sourceCodes = n.payload;
      break;
    case de.ADD_CONCEPTS_BY_IDENTIFIERS_REQUEST:
    case de.ADD_CONCEPTS_BY_SOURCE_CODES_REQUEST:
      s.isCompleteDownload = !1;
      break;
    case de.ADD_CONCEPTS_BY_IDENTIFIERS_REQUEST_DONE:
    case de.ADD_CONCEPTS_BY_SOURCE_CODES_REQUEST_DONE:
      s.isCompleteDownload = !0, s.objectExtendConcepts = n.payload;
      break;
    case de.SWITCH_CHECK_MODE:
      s.checkState = n.payload;
      break;
  }
}), No = {
  identifiers: "",
  sourceCodes: "",
  isCompleteDownload: !1,
  objectExtendConcepts: {},
  checkState: !1,
  extendOptions: {}
}, jo = () => {
  const [t, n] = Pe(
    bo,
    No
  ), s = (E) => {
    n({
      type: de.UPDATE_IDENTIFIERS,
      payload: E
    });
  }, a = (E) => {
    n({
      type: de.UPDATE_SOURCE_CODES,
      payload: E
    });
  }, c = (E, r) => {
    switch (E) {
      case ze.IDENTIFIERS:
        s(r);
        break;
      case ze.SOURCE_CODES:
        a(r);
        break;
    }
  }, d = $(
    async (E) => {
      n({
        type: de.ADD_CONCEPTS_BY_IDENTIFIERS_REQUEST
      });
      try {
        n({
          type: de.ADD_CONCEPTS_BY_IDENTIFIERS_REQUEST_DONE,
          payload: E
        });
      } catch {
      }
    },
    [t.identifiers]
  );
  return {
    ...t,
    updateIds: c,
    addConcepts: (E) => {
      d(E);
    },
    switchCheckMode: (E) => {
      n({
        type: de.SWITCH_CHECK_MODE,
        payload: E
      });
    }
  };
}, Jt = (t) => {
  const {
    id: n,
    onClickConcept: s,
    onChangeConcept: a,
    onSelectConcept: c,
    selectedConcepts: d,
    isNativeHierarchy: C,
    viewMode: h
  } = t, E = Ut(), r = Ut(), l = Zt(
    n,
    Ht.ANCESTORS,
    C,
    E.form
  ), i = Zt(
    n,
    Ht.DESCENDANTS,
    C,
    r.form
  );
  return /* @__PURE__ */ e.jsxs(
    U,
    {
      sx: {
        ".collapsible-block": {
          mb: 1
        }
      },
      children: [
        /* @__PURE__ */ e.jsx(
          po,
          {
            id: n,
            onChangeConcept: a,
            onClickConcept: s,
            onSelectConcept: c,
            selectedConcepts: d,
            filtersAncestors: E,
            relatedAncestors: l,
            isNativeHierarchy: C,
            viewMode: h
          }
        ),
        /* @__PURE__ */ e.jsx(
          Co,
          {
            id: n,
            onChangeConcept: a,
            onClickConcept: s,
            onSelectConcept: c,
            selectedConcepts: d,
            filtersDescendants: r,
            relatedDescendants: i,
            isNativeHierarchy: C,
            viewMode: h
          }
        )
      ]
    }
  );
};
Q.div`
  padding: 15px 20px;
  .concept-details__row {
    font-size: ${({ theme: t }) => {
  var n;
  return (n = t.typography) == null ? void 0 : n.fontSize;
}}px;
    border-bottom: 1px solid #dae1ee;
    padding: 8px;
    :hover {
      background-color: #dae1ee;
    }
  }
  .concept-details__row-heading {
    font-weight: bold;
    background-color: #dae1ee;
  }
  white-space: pre-wrap;
`;
Q.div`
  color: ${({ color: t }) => t};
  margin-top: 11px;
  display: inline-block;
  /* font-weight:700; */
`;
const yo = Q.span`
  margin-right: 20px;
  position: relative;
  display: flex;
  align-items: center;
  .status-tag {
    margin-left: 8px;
  }
`;
Q.div`
  padding: 20px 20px 0;
  /* box-shadow: ${({ theme: t }) => t.customShadows[2]}; */

  // border-bottom: 3px solid #d8e1ef;
  .item:not(.active-item) {
    background-color: #ffffff;
  }
  > * {
    margin-bottom: 0;
  }
`;
const Do = Q(oe)`
  margin-left: 16px;
`;
Q(oe)`
  margin-left: 20px;
  height: 35px;
  font-size: 12px;
  font-weight: 700;
  border: none;
  background: #ffffff !important;
  color: #8fcb54;
  border-radius: 4px;
`;
Q.div`
  position: relative;
`;
Q.div`
  position: absolute;
  right: 0;
  /* TODO */
  bottom: 31px;
  margin-right: 10px;
`;
Q(Cn)`
  height: 40px;
  font-size: 12px;
  margin-top: 2px;
  .selected-title {
    color: ${({ theme: t }) => {
  var n;
  return (n = t.palette) == null ? void 0 : n.primary.main;
}};
    font-weight: 700;
    text-decoration: underline;
    padding-right: 5px;
  }
  .selected-count {
    background: #e1ecf3;
    width: 23px;
    display: inline-block;
    color: ${({ theme: t }) => {
  var n;
  return (n = t.palette) == null ? void 0 : n.primary.main;
}};
    font-weight: 700;
    padding: 4px 2px;
  }
`;
const Ao = (t, n) => {
  const s = n ? {
    value: Ae.NATIVE_HIERARCHY,
    title: "Source Hierarchy",
    onTabClick: t
  } : {
    value: Ae.HIERARCHY,
    title: "OMOP Hierarchy",
    onTabClick: t
  };
  return [
    {
      value: Ae.RELATED_CONCEPTS,
      title: "Related concepts",
      onTabClick: t
    },
    s
  ];
}, _t = Te((t) => {
  const {
    onClose: n,
    onFind: s,
    pureClose: a,
    conceptId: c,
    entryConcept: d,
    subModules: C,
    vocabularyMode: h,
    path: E,
    viewMode: r,
    typeContainer: l,
    parentId: i,
    canEdit: o = !0
  } = t, p = localStorage.getItem(
    "currentConceptSetItem"
  ), g = Ge(), m = et(), { conceptId: u } = is(), R = c || u, [y, P] = F(null);
  fe.useEffect(() => {
    d && P(d);
  }, [d]), fe.useEffect(() => {
    R && _s(R).then((_) => {
      P(we(_));
    });
  }, [R]);
  const [j, N] = F(
    Ae.RELATED_CONCEPTS
  ), [v, w] = F(!1), { enqueueSnackbar: f } = St(), {
    selectedConcepts: I,
    updateSelectedConceptBulk: b,
    detectSelectedAction: M,
    clear: k
  } = _e(), H = W(() => Ao(
    N,
    !(y != null && y.concept.STANDARD_CONCEPT)
  ), [y]), Y = (_) => /* @__PURE__ */ e.jsxs(x, { container: !0, spacing: 1, children: [
    /* @__PURE__ */ e.jsxs(x, { item: !0, xs: 12, children: [
      _ ? "Concepts" : "Concept",
      " added to draft concept set"
    ] }),
    /* @__PURE__ */ e.jsx(x, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(ds, { to: `/${E}/modal/selected`, children: /* @__PURE__ */ e.jsxs("b", { children: [
      "Navigate to draft concept set ",
      ">>"
    ] }) }) })
  ] }), Z = (_) => {
    s == null || s({
      [_.id]: _,
      ...I
    }), w(!0), f({
      message: h ? Y(!1) : "Concept added to concept set",
      variant: "success"
    });
  }, le = () => {
    s == null || s(I), k(), f({
      message: h ? Y(!0) : "Concepts added to concept set",
      variant: "success"
    });
  }, ae = ({
    original: _
  }) => {
    g(`/${E}/modal/related/${_.conceptId}`, {
      state: m.state
    }), w(!1);
  }, K = (_) => {
    const { color: O } = rt(_);
    return O;
  }, re = $((_, O) => {
    const A = Ie(_);
    M(A, O);
  }, []), T = Object.keys(I).length;
  return y && /* @__PURE__ */ e.jsxs(
    x,
    {
      container: !0,
      height: "100vh",
      sx: { overflowY: "auto" },
      alignContent: "flex-start",
      children: [
        /* @__PURE__ */ e.jsxs(x, { item: !0, xs: 12, position: "sticky", zIndex: 3, top: "0", children: [
          /* @__PURE__ */ e.jsx(Nt, { onClose: a || n, children: /* @__PURE__ */ e.jsxs(x, { container: !0, spacing: 1, alignItems: "center", children: [
            /* @__PURE__ */ e.jsx(x, { item: !0, width: 50, children: /* @__PURE__ */ e.jsx(
              oe,
              {
                sx: { minWidth: 0, padding: 1 },
                variant: "contained",
                color: "secondary",
                onClick: () => {
                  g(-1);
                },
                children: /* @__PURE__ */ e.jsx(
                  te,
                  {
                    iconName: "chevron",
                    sx: { transform: "rotate(90deg)" }
                  }
                )
              }
            ) }),
            /* @__PURE__ */ e.jsx(
              x,
              {
                item: !0,
                flexGrow: 1,
                display: "flex",
                width: "calc(100% - 50px)",
                children: /* @__PURE__ */ e.jsxs(yo, { children: [
                  y.concept.CONCEPT_NAME,
                  " ",
                  /* @__PURE__ */ e.jsx(
                    an,
                    {
                      text: y.concept.STANDARD_CONCEPT_CAPTION,
                      color: K(
                        y.concept.STANDARD_CONCEPT
                      ),
                      align: "center"
                    }
                  )
                ] })
              }
            )
          ] }) }),
          /* @__PURE__ */ e.jsx(
            As,
            {
              canEdit: o,
              concept: y,
              onEditAction: P,
              clearConceptSettings: v
            }
          ),
          /* @__PURE__ */ e.jsx(
            C.concept,
            {
              type: "component",
              name: "widget-concept-set-save",
              path: "/concept-sets",
              subModules: C,
              config: {
                typeContainer: l,
                parentId: i,
                concepts: [y],
                // TODO: finish later
                onSave: () => {
                },
                component: () => {
                  if (!r)
                    return (h || !h && R !== p) && /* @__PURE__ */ e.jsx(
                      Do,
                      {
                        onClick: () => Z(y),
                        name: "add-to-concept-set",
                        variant: "contained",
                        color: "success",
                        children: h ? "Add to draft concept set " : "Add to concept set"
                      }
                    );
                }
              }
            }
          )
        ] }),
        /* @__PURE__ */ e.jsx(x, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(ye, { elevation: 3, sx: { borderRadius: 0 }, children: /* @__PURE__ */ e.jsx(hn, { tabs: H, active: j }) }) }),
        /* @__PURE__ */ e.jsxs(
          x,
          {
            item: !0,
            xs: 12,
            container: !0,
            alignContent: "flex-start",
            p: 2,
            mb: T === 0 ? 0 : 6,
            children: [
              /* @__PURE__ */ e.jsx(
                vt,
                {
                  selectedConceptsCount: T,
                  width: window.innerWidth - 250 + "px",
                  onAdd: le,
                  onClear: k,
                  buttonText: h ? "Add to draft concept set " : "Add to concept set "
                }
              ),
              j === Ae.RELATED_CONCEPTS && /* @__PURE__ */ e.jsx(x, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
                mo,
                {
                  id: y.conceptId.toString(),
                  onChangeConcept: b,
                  onClickConcept: ae,
                  onSelectConcept: re,
                  selectedConcepts: I,
                  viewMode: r
                }
              ) }),
              j === Ae.HIERARCHY && /* @__PURE__ */ e.jsx(x, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
                Jt,
                {
                  id: y.conceptId.toString(),
                  onChangeConcept: b,
                  onClickConcept: ae,
                  onSelectConcept: re,
                  selectedConcepts: I,
                  viewMode: r
                }
              ) }),
              j === Ae.NATIVE_HIERARCHY && /* @__PURE__ */ e.jsx(x, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
                Jt,
                {
                  id: y.conceptId.toString(),
                  onChangeConcept: b,
                  onClickConcept: ae,
                  onSelectConcept: re,
                  selectedConcepts: I,
                  viewMode: r,
                  isNativeHierarchy: !0
                }
              ) })
            ]
          }
        )
      ]
    }
  );
}), Po = Q.div`
  display: flex;
  padding: 8px 0;
  justify-content: flex-end;
`, ot = Q.label`
  display: flex;
  align-items: center;
  color: ${({ theme: t }) => t.palette.textColor.primary};
  font-size: 15px;
  :not(:last-of-type) {
    margin-right: 10px;
  }
  .app-checkbox {
    margin: 0 8px;
  }
`, en = ({
  onSelect: t,
  state: n,
  setState: s,
  isConcept: a
}) => {
  const [c, d] = F(!1), [C, h] = F(!1), [E, r] = F(!1), [l, i] = F(!1);
  return /* @__PURE__ */ e.jsx(e.Fragment, { children: /* @__PURE__ */ e.jsxs(x, { container: !0, spacing: 1, children: [
    /* @__PURE__ */ e.jsx(x, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
      ss,
      {
        data: n,
        enableDownload: !1,
        onChange: s,
        height: 300
      }
    ) }),
    /* @__PURE__ */ e.jsx(x, { item: !0, xs: 12, children: !a && /* @__PURE__ */ e.jsxs(Po, { children: [
      /* @__PURE__ */ e.jsxs(ot, { htmlFor: "excluded", children: [
        /* @__PURE__ */ e.jsx(
          ce,
          {
            checked: c,
            onChange: (o) => d(o.target.checked),
            disabled: n.length == 0,
            size: "small",
            id: "excluded"
          }
        ),
        "Excluded"
      ] }),
      /* @__PURE__ */ e.jsxs(ot, { htmlFor: "descendants", children: [
        /* @__PURE__ */ e.jsx(
          ce,
          {
            checked: C,
            onChange: (o) => h(o.target.checked),
            disabled: n.length == 0,
            size: "small",
            id: "descendants"
          }
        ),
        "Descendants"
      ] }),
      /* @__PURE__ */ e.jsxs(ot, { htmlFor: "mapped", children: [
        /* @__PURE__ */ e.jsx(
          ce,
          {
            checked: E,
            onChange: (o) => r(o.target.checked),
            disabled: n.length == 0,
            size: "small",
            id: "mapped"
          }
        ),
        "Mapped"
      ] }),
      /* @__PURE__ */ e.jsxs(ot, { htmlFor: "hierarchy", children: [
        /* @__PURE__ */ e.jsx(
          ce,
          {
            checked: l,
            onChange: (o) => i(o.target.checked),
            disabled: n.length == 0,
            size: "small",
            id: "hierarchy"
          }
        ),
        "Hierarchy"
      ] })
    ] }) }),
    /* @__PURE__ */ e.jsx(x, { item: !0, xs: 12, textAlign: "right", children: /* @__PURE__ */ e.jsx(
      oe,
      {
        disabled: n.length == 0,
        onClick: () => t({
          excluded: c,
          descendants: C,
          mapped: E,
          hierarchy: l
        }),
        name: "addToCOnceptSet",
        variant: "contained",
        color: "success",
        startIcon: /* @__PURE__ */ e.jsx(te, { iconName: "submit" }),
        children: "Check concepts"
      }
    ) })
  ] }) });
}, vo = {
  entityNavigationPanel: (t) => [
    {
      value: me.CONCEPT_IDENTIFIERS,
      title: "Concept Identifiers",
      onTabClick: t
    },
    {
      value: me.SOURCE_CODES,
      title: "Source codes",
      onTabClick: t
    }
  ],
  identifiers: {
    fetch: Sn,
    parse: Zn
  },
  sourceCodes: {
    fetch: mn,
    parse: un
  }
}, wo = (t) => {
  const n = t.split(",").map((c) => c.trim()), s = [], a = [];
  return n.forEach((c) => {
    /^\d+$/.test(c) ? s.push(c) : a.push(c);
  }), { numbers: s, others: a };
}, ko = (t, n) => {
  switch (t) {
    case me.CONCEPT_IDENTIFIERS:
      return {
        getMethod: Sn,
        ids: n.identifiers,
        type: ze.IDENTIFIERS
      };
    case me.SOURCE_CODES:
      return {
        getMethod: mn,
        ids: n.sourceCodes,
        type: ze.SOURCE_CODES
      };
  }
}, Lo = ({
  type: t,
  ids: n,
  extendOptions: s = {},
  hasHierarchy: a,
  onSubmit: c
}) => {
  const [d, C] = F([]), [h, E] = F(S.INITIAL), [r, l] = F(""), [i, o] = F(!1), p = ko(t, n), {
    selectedConcepts: g,
    detectSelectedAction: m,
    updateSelectedConceptBulk: u,
    init: R
  } = _e(), y = !Object.keys(g).length, P = (f) => {
    u(Array.isArray(f) ? f : [f]);
  }, j = () => {
    E(S.IN_PROGRESS);
    const f = t == me.CONCEPT_IDENTIFIERS ? wo(p.ids) : un(p.ids);
    p.getMethod(
      t == me.CONCEPT_IDENTIFIERS ? f.numbers : f
    ).then((I) => {
      if (t == me.SOURCE_CODES) {
        const M = new Set(
          I.content.map((H) => H.CONCEPT_CODE.toUpperCase())
        ), k = f.filter(
          (H) => !M.has(H.toUpperCase())
        );
        l(k.join(", "));
      }
      if (t == me.CONCEPT_IDENTIFIERS) {
        const M = new Set(
          I.content.map((H) => H.CONCEPT_ID.toString())
        ), k = [...f.numbers, ...f.others].filter(
          (H) => !M.has(H)
        );
        l(k.join(", "));
      }
      const b = I.content.map(
        (M) => {
          const k = we(
            M,
            s
          );
          return k.concept.STANDARD_CONCEPT == "S" || k.concept.STANDARD_CONCEPT == "C" ? {
            ...k,
            hierarchy: !1
          } : {
            ...k,
            mapped: !1,
            descendants: !1
          };
        }
      );
      C(b);
    }).finally(() => E(S.SUCCESS));
  }, N = $(() => {
    o(!0), navigator.clipboard.writeText(r), Jn(() => o(!1), 2e3)();
  }, [r]), v = () => {
    es(
      r,
      "Missing identifiers.txt",
      os.APPLICATION_TEXT
    );
  }, w = $((f, I) => {
    const b = Ie(f);
    m(b, I);
  }, []);
  return V(() => {
    j();
  }, []), /* @__PURE__ */ e.jsxs(x, { container: !0, children: [
    r && /* @__PURE__ */ e.jsx(x, { item: !0, xs: 12, mb: 1, children: /* @__PURE__ */ e.jsxs(
      Ct,
      {
        severity: "warning",
        action: /* @__PURE__ */ e.jsxs(
          U,
          {
            className: "actions-container",
            sx: {
              display: "flex",
              ".actions-container__button": {
                borderRadius: 0.5,
                p: 0.5,
                ml: 1
              }
            },
            children: [
              /* @__PURE__ */ e.jsx(be, { text: "Copy identifiers", width: 130, children: /* @__PURE__ */ e.jsx(
                It,
                {
                  onClick: N,
                  className: "actions-container__button",
                  name: "copyToClipboard",
                  children: /* @__PURE__ */ e.jsx(
                    be,
                    {
                      text: "Identifiers copied to clipboard!",
                      controlled: !0,
                      show: i,
                      width: 130,
                      children: /* @__PURE__ */ e.jsx(
                        te,
                        {
                          iconName: "copy",
                          sx: { fontSize: 15 },
                          name: "Copy to clipboard"
                        }
                      )
                    }
                  )
                }
              ) }),
              /* @__PURE__ */ e.jsx(be, { text: "Download identifiers", width: 130, children: /* @__PURE__ */ e.jsx(
                It,
                {
                  onClick: v,
                  className: "actions-container__button",
                  name: "downloadFile",
                  children: /* @__PURE__ */ e.jsx(
                    te,
                    {
                      iconName: "download",
                      sx: { fontSize: 15 },
                      name: "Download as file"
                    }
                  )
                }
              ) })
            ]
          }
        ),
        children: [
          "Following identifiers were not found: ",
          /* @__PURE__ */ e.jsx("b", { children: r })
        ]
      }
    ) }),
    /* @__PURE__ */ e.jsx(x, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
      pe,
      {
        variant: "uncontrolled",
        storageKey: "concept-import",
        title: "Check concepts",
        showFilterToggle: !0,
        enableRowSelection: !0,
        hasDomainAndVocabulary: !0,
        hasRcDrc: !0,
        data: d,
        getRowId: (f) => String(f.conceptId),
        onRowSelect: w,
        reloadData: j,
        onEdit: P,
        onSelectAll: R,
        selectedConcepts: g,
        status: h,
        noGaps: !0,
        enableFiltering: !0,
        hasRcDrcSelect: !0,
        hasHierarchy: a
      }
    ) }),
    /* @__PURE__ */ e.jsx(x, { item: !0, xs: 12, textAlign: "right", children: /* @__PURE__ */ e.jsx(
      oe,
      {
        onClick: () => c(g),
        name: "addToCOnceptSet",
        variant: "contained",
        color: "success",
        startIcon: /* @__PURE__ */ e.jsx(te, { iconName: "submit" }),
        disabled: y,
        children: "Add to concept set"
      }
    ) })
  ] });
}, Nn = (t) => {
  const { onFind: n, onClose: s, isConcept: a, hasHierarchy: c } = t, [d, C] = F(
    me.CONCEPT_IDENTIFIERS
  ), [h, E] = F(), {
    checkState: r,
    identifiers: l,
    sourceCodes: i,
    objectExtendConcepts: o,
    isCompleteDownload: p,
    updateIds: g,
    switchCheckMode: m,
    addConcepts: u
  } = jo(), R = (P) => {
    m(!0), E(P);
  }, y = W(() => vo.entityNavigationPanel(C), []);
  return V(() => {
    p && (n(o), s());
  }, [p]), /* @__PURE__ */ e.jsx(x, { container: !0, children: r ? /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(ye, { elevation: 3, sx: { zIndex: 2, px: 2, py: 1, width: "100%" }, children: /* @__PURE__ */ e.jsxs(
      oe,
      {
        onClick: () => m(!1),
        variant: "text",
        size: "medium",
        children: [
          "<",
          " Back to import"
        ]
      }
    ) }),
    /* @__PURE__ */ e.jsx(x, { item: !0, xs: 12, p: 2, children: /* @__PURE__ */ e.jsx(ye, { elevation: 0, sx: { p: 2 }, children: /* @__PURE__ */ e.jsx(
      Lo,
      {
        type: d,
        ids: { identifiers: l, sourceCodes: i },
        extendOptions: h,
        onSubmit: u,
        hasHierarchy: c
      }
    ) }) })
  ] }) : /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(
      ye,
      {
        elevation: 3,
        sx: { zIndex: 2, px: 2, width: "100%", borderRadius: 0 },
        children: /* @__PURE__ */ e.jsx(hn, { tabs: y, active: d })
      }
    ),
    /* @__PURE__ */ e.jsx(x, { item: !0, xs: 12, p: 2, children: /* @__PURE__ */ e.jsxs(ye, { elevation: 3, sx: { p: 2 }, children: [
      d == me.CONCEPT_IDENTIFIERS && /* @__PURE__ */ e.jsx(
        en,
        {
          onSelect: R,
          state: l,
          setState: (P) => {
            g(ze.IDENTIFIERS, P);
          },
          isConcept: a
        }
      ),
      d == me.SOURCE_CODES && /* @__PURE__ */ e.jsx(
        en,
        {
          onSelect: R,
          state: i,
          setState: (P) => {
            g(ze.SOURCE_CODES, P);
          },
          isConcept: a
        }
      )
    ] }) })
  ] }) });
};
Q.div``;
Q.div`
  padding: 2px 15px;
`;
Q(Cn)`
  height: 40px;
  font-size: 12px;
  .selected-title {
    color: ${({ theme: t }) => {
  var n;
  return (n = t.palette) == null ? void 0 : n.primary.main;
}};
    font-weight: 700;
    text-decoration: underline;
    padding-right: 5px;
  }
  .selected-count {
    background: #e1ecf3;
    width: 23px;
    display: inline-block;
    color: ${({ theme: t }) => {
  var n;
  return (n = t.palette) == null ? void 0 : n.primary.main;
}};
    font-weight: 700;
    padding: 4px 2px;
  }
`;
Q.div`
  padding: 5px 15px;
`;
const Fo = Q(
  x
)`
  border-bottom: 1px solid ${({ theme: t }) => t.palette.borderColor.main};
  background: #fff;
`, Uo = Te((t) => {
  const { objectConcepts: n, onFind: s, onClose: a, domainId: c, standardConcept: d } = t, {
    searchData: C,
    pageCount: h,
    pageSize: E,
    status: r,
    totalElements: l,
    searchParams: { pageNumber: i, searchFilters: o },
    search: p,
    updateQuery: g
  } = kt(!0, c, d), [m, u] = F(!0), { selectedConcepts: R, detectSelectedAction: y, clear: P, init: j } = _e(n), N = () => {
    s(R), a == null || a();
  }, v = (I) => {
    g(I);
  };
  V(() => {
    u(!1);
  }, [o]);
  const w = $((I, b) => {
    const M = Ie(I);
    y(M, b);
  }, []), f = Object.keys(R).length;
  return /* @__PURE__ */ e.jsxs(x, { container: !0, children: [
    /* @__PURE__ */ e.jsx(
      vt,
      {
        onAdd: N,
        onClear: () => {
          P();
        },
        selectedConceptsCount: f,
        buttonText: "Add selected concepts",
        width: window.innerWidth - 250 + "px"
      }
    ),
    /* @__PURE__ */ e.jsx(
      Fo,
      {
        item: !0,
        xs: 12,
        p: 2,
        className: "search-query-container",
        children: /* @__PURE__ */ e.jsx(Rn, { onFind: v, dense: !0 })
      }
    ),
    /* @__PURE__ */ e.jsx(x, { item: !0, xs: 12, p: 2, pb: f ? 8 : 2, children: /* @__PURE__ */ e.jsx(We, { children: !m && /* @__PURE__ */ e.jsx(
      pe,
      {
        variant: "controlled",
        storageKey: "search-concepts-widget",
        data: C,
        pageCount: h,
        pageSize: E,
        fetchData: p,
        pageIndex: i,
        status: r,
        totalElements: l,
        onSelectAll: j,
        getRowId: (I) => String(I.conceptId),
        selectedConcepts: R,
        onRowSelect: w,
        title: "All concepts",
        hasRcDrc: !0,
        hasRcDrcSelect: !0,
        enableRowSelection: !0,
        hasHierarchy: !1,
        outlined: !0
      }
    ) }) })
  ] });
}), Mo = Q.div`
  /* padding-top: 0px; */
  .search-query-container {
    background-color: white;
    padding: 16px;
    box-shadow: ${({ theme: t }) => t.customShadows[2]};
  }
`, zo = Te((t) => {
  const {
    onClose: n,
    onFind: s,
    subModules: a,
    vocabularyMode: c,
    path: d,
    typeContainer: C,
    parentId: h,
    viewMode: E
  } = t, r = Ge(), l = et(), i = "/modal", o = l.pathname.indexOf(i), p = o !== -1 ? l.pathname.slice(0, o) || "/" : l.pathname || "/", [g, m] = F(), u = (() => {
    const j = l.pathname.match(/\/modal\/related\/([^/]+)/);
    return j == null ? void 0 : j[1];
  })(), R = (j) => {
    m(j), r(
      `${p}${i}/related/${j.conceptId}${l.search || ""}`
    );
  }, y = () => {
    m(null), r(`${p}${i}${l.search || ""}`, {
      replace: !0
    });
  }, P = (j) => {
    s(j), n();
  };
  return /* @__PURE__ */ e.jsx(x, { container: !0, children: /* @__PURE__ */ e.jsx(x, { item: !0, xs: 12, children: u ? /* @__PURE__ */ e.jsx(
    _t,
    {
      entryConcept: g,
      conceptId: u,
      onClose: n,
      onFind: s,
      subModules: a,
      onSearchHandler: y,
      vocabularyMode: c,
      path: d,
      typeContainer: C,
      parentId: h,
      viewMode: E
    }
  ) : /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(Nt, { onClose: n, children: "Search" }),
    /* @__PURE__ */ e.jsx(Mo, { children: /* @__PURE__ */ e.jsx(
      On,
      {
        onRowClickAction: R,
        onSubmitAction: P,
        draftSelectedConceptsCount: void 0,
        openSelectedArea: void 0,
        vocabularyMode: !1,
        showOutlet: !1,
        replaceSearchParams: !0
      }
    ) })
  ] }) }) });
}), Go = /* @__PURE__ */ new Set([
  "fullSearch",
  "advancedSearch",
  "pageNumber"
]), Ho = Te(
  (t) => {
    var Re, ke, G;
    const {
      concepts: n,
      onChange: s,
      vocabularyMode: a,
      subModules: c,
      viewMode: d,
      typeContainer: C,
      parentId: h,
      mode: E
    } = t, { openModal: r, closeModal: l } = pt(ln), i = Ge(), o = et(), p = "/modal", g = W(() => {
      const L = o.pathname.indexOf(p);
      return L !== -1 ? o.pathname.slice(0, L) || "/" : o.pathname || "/";
    }, [o.pathname]), m = W(
      () => o.pathname.includes(p),
      [o.pathname]
    ), u = $(
      (L) => {
        const J = g.endsWith("/") ? g.slice(0, -1) : g, Ee = L ? `/${L.replace(/^\/+/, "")}` : "";
        i(
          `${J || ""}${p}${Ee}${o.search || ""}`
        );
      },
      [g, o.search, i]
    ), {
      objectConcepts: R,
      reinitialConcepts: y,
      createConcepts: P,
      removeConcepts: j,
      updateConceptsBulk: N,
      status: v,
      updateStatus: w,
      reloadConceptData: f
    } = go(n, E), { selectedConcepts: I, detectSelectedAction: b, init: M, clear: k } = _e({}, "id"), H = (L) => {
      P(L);
    }, Y = () => {
      r(
        () => /* @__PURE__ */ e.jsx(Nn, { onFind: H, onClose: l }),
        "Import concepts",
        {
          onClose: l,
          closeOnClickOutside: !0
        }
      );
    }, Z = ({
      updated: L,
      deleted: J
    }) => {
      N(Object.values(L)), j(J), l();
    }, le = () => {
      r(
        () => /* @__PURE__ */ e.jsx(
          Xs,
          {
            items: R,
            onUpdate: Z
          }
        ),
        "Convert concepts",
        {
          onClose: l,
          closeOnClickOutside: !0
        }
      );
    }, ae = () => {
      u();
    }, K = () => {
      r(
        () => /* @__PURE__ */ e.jsx(
          so,
          {
            items: R,
            onClose: l,
            onOverwriteConceptSet: y,
            subModules: c
          }
        ),
        "Concept set optimization",
        {
          onClose: l,
          closeOnClickOutside: !0
        }
      );
    }, re = (L) => {
      localStorage.setItem(
        "currentConceptSetItem",
        String(L.original.conceptId)
      ), u(`related/${L.original.conceptId}`);
    }, T = (L) => {
      const Ee = (Array.isArray(L) ? L : [L]).reduce((Le, An) => {
        const { row: Lt, columnId: Pn, value: vn } = An;
        return Le[Lt.id] = { ...Lt, [Pn]: vn }, Le;
      }, {});
      N(Object.values(Ee));
    }, _ = () => {
      j(I), k();
    }, O = $((L, J) => {
      const Ee = Ie(L, {}, "id");
      b(Ee, J);
    }, []), A = $((L) => {
      const J = new URLSearchParams(L);
      Array.from(J.keys()).forEach((Le) => {
        (Go.has(Le) || Le.startsWith("filter.")) && J.delete(Le);
      });
      const Ee = J.toString();
      return Ee ? `?${Ee}` : "";
    }, []), D = () => {
      i(
        `${g}${A(
          o.search || ""
        )}`,
        { replace: !0 }
      );
    };
    V(() => {
      n && !Me(R, n) && y(n);
    }, [n]), V(() => {
      s(R);
    }, [R]);
    const z = (Re = Object.keys(I)) == null ? void 0 : Re.length, ie = (ke = Object.keys(R)) == null ? void 0 : ke.length, Ce = "Concept Set Expression is a `formula`, that allows to present large concept lists in a more compact way with the help of features like Exclude, Descendants, Mapped and Hierarchy. Hover over the corresponding icons in the table for detailed tooltip.", q = a ? void 0 : /* @__PURE__ */ e.jsx(be, { text: Ce, placement: "bottom", width: 420, children: /* @__PURE__ */ e.jsxs(In, { children: [
      /* @__PURE__ */ e.jsx(Pt, {}),
      /* @__PURE__ */ e.jsx("span", { children: Ce })
    ] }) }), he = (G = Object.values(R)) == null ? void 0 : G.some(
      (L) => {
        var J, Ee;
        return ((J = L == null ? void 0 : L.concept) == null ? void 0 : J.STANDARD_CONCEPT) !== "S" && ((Ee = L == null ? void 0 : L.concept) == null ? void 0 : Ee.STANDARD_CONCEPT) !== "C";
      }
    );
    return /* @__PURE__ */ e.jsxs(x, { container: !0, children: [
      /* @__PURE__ */ e.jsx(x, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
        pe,
        {
          variant: "uncontrolled",
          storageKey: "concept-expression",
          hiddenColumns: {
            RECORD_COUNT: !1,
            DESCENDANT_RECORD_COUNT: !1,
            PERSON_COUNT: !1,
            DESCENDANT_PERSON_COUNT: !1
          },
          filtersDefaultClosed: !0,
          showFilterToggle: !0,
          hasHierarchy: !0,
          enableRowSelection: !d,
          disableEdit: d,
          disabled: w === S.IN_PROGRESS,
          title: a ? "All selected concepts" : "All concept set items",
          headerInfo: q,
          data: Object.values(R),
          getRowId: (L) => L.id,
          selectedConcepts: I,
          onRowSelect: O,
          onEdit: T,
          onSelectAll: M,
          onRowClick: re,
          reloadData: f,
          status: v,
          hasRcDrcSelect: !0,
          outlined: !0,
          enableFiltering: !0,
          customActions: !d && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
            /* @__PURE__ */ e.jsx(
              ge,
              {
                iconName: "delete",
                title: "Delete",
                color: "error",
                onClick: _,
                name: "delete-selected",
                disabled: z < 1,
                count: z,
                tooltipText: "Delete"
              }
            ),
            !a && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
              /* @__PURE__ */ e.jsx(
                ge,
                {
                  iconName: "import",
                  title: "Import",
                  color: "default",
                  onClick: Y,
                  name: "import-codes",
                  tooltipText: "Import"
                }
              ),
              /* @__PURE__ */ e.jsx(
                ge,
                {
                  onClick: le,
                  color: "default",
                  iconName: "reload",
                  title: "Convert",
                  tooltipText: he ? "Convert non-standard to standard" : "Nothing to convert",
                  disabled: !he
                }
              ),
              E !== "embedded" && /* @__PURE__ */ e.jsx(
                ge,
                {
                  iconName: "optimize",
                  title: "Optimize",
                  color: "default",
                  onClick: K,
                  name: "optimize-codes",
                  tooltipText: "Optimize",
                  disabled: !ie
                }
              ),
              /* @__PURE__ */ e.jsx(
                ht,
                {
                  iconName: "add",
                  title: "Add",
                  color: "success",
                  onClick: ae,
                  name: "add-from-vocab",
                  tooltipText: "Add"
                }
              )
            ] })
          ] })
        }
      ) }),
      m && /* @__PURE__ */ e.jsx(Ye, { open: !0, onClose: D, children: /* @__PURE__ */ e.jsx(
        zo,
        {
          onFind: P,
          subModules: c,
          onClose: D,
          vocabularyMode: !1,
          path: g.replace(/^\/+/, ""),
          typeContainer: C,
          parentId: h,
          viewMode: d
        }
      ) })
    ] });
  }
), tn = (t) => {
  const {
    // concepts: objectConcepts, - not used
    subModules: n,
    onChange: s,
    method: a,
    filtersMethod: c,
    onFinish: d,
    path: C,
    viewMode: h,
    listType: E
  } = t, {
    fetchIncluded: r,
    status: l,
    pageCount: i,
    pageNumber: o,
    pageSize: p,
    totalElements: g,
    includedItems: m,
    filters: u,
    filtersForm: R,
    filtersStatus: y,
    updateFilters: P
  } = Oo({ get: a, getFilters: c }, E), {
    selectedConcepts: j,
    detectSelectedAction: N,
    updateSelectedConcept: v,
    init: w
  } = _e(), f = Ge(), I = et(), b = "/modal", M = I.pathname.indexOf(b), k = M !== -1 ? I.pathname.slice(0, M) || "/" : I.pathname || "/", H = (D) => {
    f(
      `${k}${b}/related/${D.original.conceptId}${I.search || ""}`
    );
  }, Y = () => {
    Z(j);
  }, Z = (D) => {
    s(Rt(D)), d();
  }, le = (D) => {
    const z = {
      ...j[D.row.conceptId],
      [D.columnId]: D.value
    };
    v(z);
  }, { otherFilters: ae, searchFilter: K } = Je(
    u,
    "fullSearch"
  ), re = $((D, z) => {
    const ie = Ie(D);
    N(ie, z);
  }, []), T = Object.keys(j).length, _ = Object.values(R).some(
    (D) => (D == null ? void 0 : D.length) > 0
  ), O = E === Qe.INCLUDED_CONCEPTS ? "Included concepts is a final resolved list of concepts, which are used to query the database (concept_id or source_concept_id field in event tables)." : "All included concepts and implicitly included (via maps_to relationship) source codes.", A = /* @__PURE__ */ e.jsx(be, { text: O, placement: "bottom", width: 420, children: /* @__PURE__ */ e.jsxs(In, { children: [
    /* @__PURE__ */ e.jsx(Pt, {}),
    /* @__PURE__ */ e.jsx("span", { children: O })
  ] }) });
  return /* @__PURE__ */ e.jsxs(x, { container: !0, children: [
    /* @__PURE__ */ e.jsx(x, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
      pe,
      {
        title: E === Qe.INCLUDED_CONCEPTS ? "All included concepts" : "Included source codes",
        headerInfo: A,
        storageKey: E === Qe.INCLUDED_CONCEPTS ? "concept-set-included" : "concept-set-source-codes",
        disableEdit: !0,
        hasHierarchy: !1,
        enableRowSelection: !h,
        data: m,
        pageCount: i,
        pageSize: p,
        pageIndex: o,
        totalElements: g,
        fetchData: r,
        getRowId: (D) => String(D.conceptId),
        selectedConcepts: j,
        onRowSelect: re,
        onEdit: le,
        onSelectAll: w,
        onRowClick: H,
        status: l,
        hasRcDrcSelect: !0,
        outlined: !0,
        variant: "controlled",
        hasFilters: _,
        showFilterToggle: !0,
        filtersDefaultClosed: !0,
        searchComponent: K && /* @__PURE__ */ e.jsx(
          mt,
          {
            ...K,
            value: R == null ? void 0 : R[K == null ? void 0 : K.name],
            onChange: (D) => P({ [K == null ? void 0 : K.name]: D })
          }
        ),
        customActions: !h && /* @__PURE__ */ e.jsxs(
          oe,
          {
            disabled: !T,
            onClick: Y,
            color: "info",
            variant: "contained",
            startIcon: /* @__PURE__ */ e.jsx(te, { iconName: "add" }),
            name: "add-to-concept-set",
            sx: { ml: 2 },
            children: [
              "Add to concept set",
              /* @__PURE__ */ e.jsx(as, { sx: { ml: 1 }, dense: !0, inverted: !0, disabled: !T, children: T })
            ]
          }
        ),
        children: /* @__PURE__ */ e.jsx(
          Xe,
          {
            showLabel: !0,
            filters: ae,
            value: R,
            onChange: (D, z) => {
              const ie = { [D]: z };
              P(ie);
            },
            isLoading: y === S.IN_PROGRESS,
            isReloading: y === S.IN_PROGRESS_RELOAD
          }
        )
      }
    ) }),
    /* @__PURE__ */ e.jsx(En, { children: /* @__PURE__ */ e.jsx(
      at,
      {
        path: "modal/related/:conceptId",
        element: /* @__PURE__ */ e.jsx(
          Ye,
          {
            open: !0,
            onClose: () => {
              f(`${k}${I.search || ""}`);
            },
            children: /* @__PURE__ */ e.jsx(
              _t,
              {
                subModules: n,
                onClose: () => {
                  f(`${k}${I.search || ""}`);
                },
                onFind: Z,
                vocabularyMode: !1,
                path: C,
                viewMode: h
              }
            )
          }
        )
      }
    ) })
  ] });
}, $o = Te((t) => {
  const { onFind: n, domainId: s, standardConcept: a } = t, { openModal: c, closeModal: d } = pt(ln), C = (r) => {
    const l = Object.keys(r).map(
      (i) => r[i].concept
    );
    n(l);
  }, h = () => {
    c(
      () => /* @__PURE__ */ e.jsx(
        Uo,
        {
          objectConcepts: {},
          onFind: C,
          domainId: s,
          standardConcept: a,
          onClose: d
        }
      ),
      "Add concepts",
      {
        onClose: d,
        closeOnClickOutside: !0
      }
    );
  }, E = () => {
    c(
      () => /* @__PURE__ */ e.jsx(
        Nn,
        {
          onFind: C,
          onClose: d,
          isConcept: !0,
          hasHierarchy: !1
        }
      ),
      "Import concepts",
      {
        onClose: d,
        closeOnClickOutside: !0
      }
    );
  };
  return /* @__PURE__ */ e.jsx("div", { children: /* @__PURE__ */ e.jsxs(x, { container: !0, spacing: 1, children: [
    /* @__PURE__ */ e.jsx(x, { item: !0, children: /* @__PURE__ */ e.jsx(
      oe,
      {
        onClick: h,
        fullWidth: !1,
        variant: "outlined",
        name: "addConcept",
        startIcon: /* @__PURE__ */ e.jsx(te, { iconName: "add" }),
        children: "Add"
      }
    ) }),
    /* @__PURE__ */ e.jsx(x, { item: !0, children: /* @__PURE__ */ e.jsx(
      oe,
      {
        onClick: E,
        fullWidth: !1,
        variant: "outlined",
        name: "importConcept",
        startIcon: /* @__PURE__ */ e.jsx(te, { iconName: "import" }),
        children: "Import"
      }
    ) })
  ] }) });
});
function jn(t, n, s) {
  const [a, c] = F(
    s ?? Ke.INITIAL
  ), [d, C] = F(
    S.INITIAL
  ), [h, E] = F(
    S.INITIAL
  ), [r, l] = F({
    prompt: "",
    items: [],
    domain: [],
    vocabulary: [],
    standard: []
  }), i = async (p) => {
    C(S.IN_PROGRESS);
    try {
      await Os(t, p), C(S.SUCCESS);
    } catch (g) {
      console.error(g);
    }
  }, o = $(async () => {
    E(S.IN_PROGRESS);
    try {
      const p = await bs(t);
      l(p), E(S.SUCCESS);
    } catch (p) {
      console.error(p), E(S.ERROR);
    }
  }, [t]);
  return V(() => {
    s !== void 0 && c(s);
  }, [s]), V(() => {
    a === Ke.DONE && o();
  }, [a, o]), {
    suggestionResult: r,
    suggestionStatus: a,
    suggestionResultStatus: h,
    createSuggestionStatus: d,
    getAiSuggestion: i
  };
}
const yn = "ai-suggested-concepts:group-by-article", Bo = () => {
  try {
    return localStorage.getItem(yn) === "true";
  } catch {
    return !1;
  }
}, Vo = (t) => {
  if (!t) return [];
  try {
    const n = JSON.parse(t);
    return Array.isArray(n) ? n : [];
  } catch {
    return [];
  }
}, Qo = (t) => {
  var a;
  const n = (t == null ? void 0 : t.conceptId) ?? ((a = t == null ? void 0 : t.concept) == null ? void 0 : a.CONCEPT_ID), s = Dt();
  return !t || !n || !(t != null && t.concept) ? null : {
    id: s,
    conceptId: Number(n),
    concept: t.concept,
    descendants: !!t.descendants,
    mapped: !!t.mapped,
    excluded: !!t.excluded,
    hierarchy: !!t.hierarchy
  };
}, Wo = ({
  concepts: t,
  viewMode: n,
  id: s,
  onChange: a,
  onFinish: c,
  suggestionStatus: d,
  delta: C
}) => {
  const { suggestionResult: h, suggestionResultStatus: E, suggestionStatus: r } = jn(s, C, d), [l, i] = F(Bo), [o, p] = F({ textWrap: !1 });
  V(() => {
    try {
      localStorage.setItem(
        yn,
        String(l)
      );
    } catch {
    }
  }, [l]);
  const { selectedConcepts: g, detectSelectedAction: m, updateSelectedConcept: u } = _e({}, "id"), R = (_) => {
    const A = {
      ...g[_.row.id] || g[_.row.conceptId] || _.row,
      [_.columnId]: _.value
    };
    u(A);
  }, y = $((_, O) => {
    const A = Ie(_, {}, "id");
    m(A, O);
  }, []), P = (_) => {
    const O = Object.values(_).reduce((A, D) => {
      const z = Qo(D);
      return z && (A[z.id] = z), A;
    }, {});
    a == null || a(O), c == null || c();
  }, j = () => {
    P(g);
  }, N = W(() => {
    const _ = /* @__PURE__ */ new Set();
    return Object.entries(t || {}).forEach(([O, A]) => {
      const D = A;
      _.add(String((D == null ? void 0 : D.conceptId) ?? (D == null ? void 0 : D.id) ?? O));
    }), _;
  }, [t]), v = W(() => Object.entries((h == null ? void 0 : h.items) || {}).map(([_, O]) => {
    var Ce;
    const A = O, D = String(
      (A == null ? void 0 : A.conceptId) ?? ((Ce = A == null ? void 0 : A.concept) == null ? void 0 : Ce.CONCEPT_ID) ?? ""
    ), z = String((A == null ? void 0 : A.id) ?? _ ?? D), ie = !!(A != null && A.existed || D && N.has(D));
    return {
      ...A,
      id: z,
      existed: ie,
      aiStudies: Vo(A.description)
    };
  }), [h, N]), w = W(() => {
    const _ = /* @__PURE__ */ new Map();
    return v.forEach((O) => {
      const A = O.aiStudies || [];
      if (A.length === 0) {
        const D = "no-article";
        _.has(D) || _.set(D, {
          id: D,
          study_name: "No article",
          study_link: "",
          concepts: []
        }), _.get(D).concepts.push({ ...O });
        return;
      }
      A.forEach((D) => {
        const z = D.study_link || D.study_name || "no-article";
        _.has(z) || _.set(z, {
          id: z,
          study_name: D.study_name || "Article",
          study_link: D.study_link || "",
          concepts: []
        }), _.get(z).concepts.push({
          ...O,
          aiStudyReasoning: D.reasoning
        });
      });
    }), Array.from(_.values()).map((O) => ({
      ...O,
      conceptsCount: O.concepts.length
    }));
  }, [v]), f = Object.keys(g).length, I = W(
    () => Object.keys(g).reduce((_, O) => (_[O] = !0, _), {}),
    [g]
  ), b = W(
    () => [
      {
        header: "Article",
        accessorKey: "study_name",
        id: "ARTICLE",
        size: 360,
        filterFn: (_, O, A) => {
          const D = ((A == null ? void 0 : A[0]) || "").toLowerCase();
          return [_.original.study_name, _.original.study_link].some(
            (z) => String(z || "").toLowerCase().includes(D)
          );
        },
        meta: {
          filterVariant: "value"
        },
        cell: ({ row: _ }) => {
          const O = _.original.study_link, A = Gt(O), D = o.textWrap;
          return /* @__PURE__ */ e.jsxs(U, { sx: { maxWidth: "100%" }, children: [
            /* @__PURE__ */ e.jsx(
              se,
              {
                variant: "body2",
                title: _.original.study_name,
                sx: {
                  fontSize: 13,
                  whiteSpace: D ? "normal" : "nowrap",
                  overflow: D ? "visible" : "hidden",
                  textOverflow: D ? "clip" : "ellipsis",
                  wordBreak: D ? "break-word" : "normal"
                },
                children: _.original.study_name
              }
            ),
            O && /* @__PURE__ */ e.jsx(
              se,
              {
                variant: "body2",
                title: O,
                ...A ? {
                  component: "a",
                  href: O,
                  target: "_blank"
                } : {},
                sx: {
                  textDecoration: A ? "underline" : "none",
                  display: D ? "block" : "inline-flex",
                  fontSize: 12,
                  color: "text.secondary",
                  maxWidth: 520,
                  whiteSpace: D ? "normal" : "nowrap",
                  overflow: D ? "visible" : "hidden",
                  textOverflow: D ? "clip" : "ellipsis",
                  wordBreak: D ? "break-word" : "normal"
                },
                children: O
              }
            )
          ] });
        },
        sortingFn: "alphanumeric"
      },
      {
        header: "Concepts",
        accessorKey: "conceptsCount",
        id: "CONCEPTS_COUNT",
        size: 30,
        meta: {
          align: "center",
          headerAlign: "center"
        }
      }
    ],
    [o.textWrap]
  ), M = W(
    () => Tn(
      !0,
      !1,
      !1,
      !1,
      n,
      void 0
    ),
    [n]
  ), k = W(
    () => [
      ...M,
      {
        header: "Reasoning",
        accessorKey: "aiStudyReasoning",
        id: "AI_REASONING",
        size: 360,
        cell: ({ getValue: _ }) => {
          const O = _();
          return /* @__PURE__ */ e.jsx(
            se,
            {
              variant: "body2",
              sx: {
                fontSize: 12,
                color: "text.secondary",
                lineHeight: 1.6
              },
              children: typeof O == "string" ? O : ""
            }
          );
        }
      }
    ],
    [M]
  ), H = W(
    () => b.slice(),
    [b]
  ), Y = W(
    () => k.slice(),
    [k]
  ), Z = W(
    () => M.slice(),
    [M]
  ), le = W(() => v.slice(), [v]), ae = {
    fontSize: 13,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "block",
    maxWidth: "100%"
  }, K = W(
    () => [
      {
        header: "Article",
        id: "study_name",
        accessorKey: "study_name",
        size: 400,
        cell: ({ row: _ }) => {
          const O = _.original.study_name || "-";
          return /* @__PURE__ */ e.jsx(se, { variant: "body2", title: O, sx: ae, children: O });
        }
      },
      {
        header: "Article link",
        id: "study_link",
        accessorKey: "study_link",
        size: 400,
        cell: ({ row: _ }) => {
          const O = _.original.study_link || "", A = Gt(O);
          return /* @__PURE__ */ e.jsx(
            se,
            {
              variant: "body2",
              title: O,
              ...A ? { component: "a", href: O, target: "_blank" } : {},
              sx: {
                ...ae,
                fontSize: 12,
                color: A ? "primary.main" : "text.secondary",
                textDecoration: A ? "underline" : "none"
              },
              children: O || "-"
            }
          );
        }
      }
    ],
    []
  ), re = W(
    () => K.slice(),
    [K]
  ), T = $(
    ({ row: _ }) => {
      const A = _.original.aiStudies || [];
      return A.length ? /* @__PURE__ */ e.jsx(
        U,
        {
          sx: {
            px: 3,
            py: 2,
            bgcolor: "backgroundColor.main",
            borderBottom: "1px solid",
            borderColor: "rgb(225, 229, 238)"
          },
          children: /* @__PURE__ */ e.jsx(
            je,
            {
              variant: "uncontrolled",
              data: A,
              columns: re,
              hideSettings: !0,
              hidePagination: !0,
              enableFiltering: !1,
              noDataText: "No articles"
            }
          )
        }
      ) : null;
    },
    [re]
  );
  return r === Ke.IN_PROGRESS ? (
    // Fill the available height and show the same picture as the
    // Cohort/Concept-set generation loading screen (PRO-3955 #3.1/#3.2).
    /* @__PURE__ */ e.jsx(
      At,
      {
        background: "/images/back.png",
        style: { minHeight: 400 },
        children: /* @__PURE__ */ e.jsx($n, { text: "Generating AI suggestions" })
      }
    )
  ) : /* @__PURE__ */ e.jsx(x, { container: !0, children: /* @__PURE__ */ e.jsx(x, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(
    Se,
    {
      outlined: !0,
      title: /* @__PURE__ */ e.jsx(
        Fe,
        {
          title: "Concepts from External Publication, suggested by AI",
          count: v.length,
          loading: E === S.IN_PROGRESS || E === S.IN_PROGRESS_RELOAD
        }
      ),
      actions: /* @__PURE__ */ e.jsxs(U, { display: "flex", alignItems: "center", children: [
        /* @__PURE__ */ e.jsxs(
          U,
          {
            display: "flex",
            alignItems: "center",
            mr: 2,
            onClick: (_) => {
              _.stopPropagation();
            },
            children: [
              /* @__PURE__ */ e.jsx(
                se,
                {
                  variant: "body2",
                  sx: { mr: 1, whiteSpace: "nowrap", color: "text.secondary" },
                  children: "Group by:"
                }
              ),
              /* @__PURE__ */ e.jsx(
                se,
                {
                  variant: "body2",
                  sx: {
                    mr: 1,
                    whiteSpace: "nowrap",
                    fontWeight: l ? 400 : 600,
                    opacity: l ? 0.7 : 1
                  },
                  children: "Concept"
                }
              ),
              /* @__PURE__ */ e.jsx(U, { mr: 1, children: /* @__PURE__ */ e.jsx(
                cn,
                {
                  id: "group-by-article",
                  value: l,
                  checked: l,
                  onChange: () => {
                    i((_) => !_);
                  },
                  size: "small",
                  color: "info"
                }
              ) }),
              /* @__PURE__ */ e.jsx(
                se,
                {
                  component: "label",
                  htmlFor: "group-by-article",
                  variant: "body2",
                  sx: {
                    cursor: "pointer",
                    whiteSpace: "nowrap",
                    fontWeight: l ? 600 : 400,
                    opacity: l ? 1 : 0.7
                  },
                  children: "Article"
                }
              )
            ]
          }
        ),
        !n && /* @__PURE__ */ e.jsxs(
          oe,
          {
            disabled: !f,
            onClick: j,
            color: "info",
            variant: "contained",
            startIcon: /* @__PURE__ */ e.jsx(te, { iconName: "add" }),
            name: "add-to-concept-set",
            children: [
              "Add to concept set",
              /* @__PURE__ */ e.jsx(
                Bn,
                {
                  sx: { ml: 1 },
                  dense: !0,
                  inverted: !0,
                  disabled: !f,
                  children: f
                }
              )
            ]
          }
        )
      ] }),
      children: l ? /* @__PURE__ */ e.jsx(
        je,
        {
          variant: "uncontrolled",
          data: w,
          columns: H,
          settingsOptions: o,
          onSettingsChange: p,
          enableFiltering: !0,
          filtersDefaultClosed: !0,
          showFilterToggle: !0,
          loading: E === S.IN_PROGRESS || E === S.IN_PROGRESS_RELOAD,
          loadingMessage: "Loading AI suggested concepts...",
          noDataText: "No AI suggested concepts",
          isExpandable: !0,
          getRowCanExpand: (_) => {
            var O;
            return ((O = _.original.concepts) == null ? void 0 : O.length) > 0;
          },
          renderExpandedRow: ({ row: _ }) => /* @__PURE__ */ e.jsx(
            x,
            {
              container: !0,
              width: "100%",
              bgcolor: "backgroundColor.main",
              borderBottom: "1px solid",
              borderColor: "rgb(225, 229, 238)",
              sx: {
                ".table-actions__container, .table-pagination__container": {
                  px: 1
                },
                ".table-row-expanded > td": {
                  padding: 0
                },
                ".disabled__table-row": {
                  pointerEvents: "all",
                  input: {
                    pointerEvents: "none"
                  }
                }
              },
              children: /* @__PURE__ */ e.jsx(x, { item: !0, xs: 12, px: 1, py: 1, children: /* @__PURE__ */ e.jsx(
                je,
                {
                  variant: "uncontrolled",
                  data: _.original.concepts,
                  columns: Y,
                  settingsOptions: o,
                  enableRowSelection: !0,
                  onRowSelect: y,
                  onEdit: R,
                  selectedRowIds: I,
                  disableRowSelect: (O) => O.original.existed === !0,
                  getRowId: (O) => {
                    const A = O;
                    return String(A.id ?? A.conceptId);
                  },
                  enableFiltering: !1,
                  hideSettings: !0,
                  pageSize: 10,
                  loading: !1,
                  noDataText: "No concepts for this article",
                  defaultSorting: { desc: !0, id: "STANDARD_CONCEPT" }
                }
              ) })
            }
          )
        }
      ) : /* @__PURE__ */ e.jsx(
        je,
        {
          variant: "uncontrolled",
          data: le,
          columns: Z,
          settingsOptions: o,
          onSettingsChange: p,
          enableFiltering: !0,
          filtersDefaultClosed: !0,
          showFilterToggle: !0,
          enableRowSelection: !0,
          onRowSelect: y,
          onEdit: R,
          selectedRowIds: I,
          disableRowSelect: (_) => _.original.existed === !0,
          getRowId: (_) => {
            const O = _;
            return String(O.id ?? O.conceptId);
          },
          isExpandable: !0,
          getRowCanExpand: (_) => {
            var O;
            return !!((O = _.original.aiStudies) != null && O.length);
          },
          renderExpandedRow: T,
          loading: E === S.IN_PROGRESS || E === S.IN_PROGRESS_RELOAD,
          loadingMessage: "Loading AI suggested concepts...",
          noDataText: "No AI suggested concepts",
          defaultSorting: { desc: !0, id: "STANDARD_CONCEPT" }
        }
      )
    }
  ) }) });
}, Tt = (t, n) => {
  var s;
  return typeof t != "string" ? t.name : ((s = n.find((a) => a.value === t)) == null ? void 0 : s.name) || t;
}, Yo = ({
  onClose: t,
  id: n,
  onFinish: s,
  suggestionStatus: a,
  conceptSetName: c
}) => {
  var y, P, j, N, v, w;
  const { enqueueSnackbar: d } = St(), {
    suggestionStatus: C,
    suggestionResultStatus: h,
    createSuggestionStatus: E,
    suggestionResult: r,
    getAiSuggestion: l
  } = jn(n, void 0, a), [i, o] = F({
    prompt: (r == null ? void 0 : r.prompt) || "",
    domain: (r == null ? void 0 : r.domain) || [],
    standard: (r == null ? void 0 : r.standard) || [],
    vocabulary: (r == null ? void 0 : r.vocabulary) || []
  }), { options: p, status: g } = Qn(), m = $((f) => {
    const { name: I, value: b } = f.target;
    o((M) => ({ ...M, [I]: b }));
  }, []), u = $(
    (f, I) => {
      o((b) => ({ ...b, [f]: I }));
    },
    []
  ), R = async () => {
    try {
      if (n && i.prompt)
        await l({
          prompt: i.prompt,
          domain: i.domain.map(
            (f) => typeof f == "string" ? f : f.value
          ),
          vocabulary: i.vocabulary.map(
            (f) => typeof f == "string" ? f : f.value
          ),
          standard: i.standard.map(
            (f) => typeof f == "string" ? f : f.value
          )
        });
      else
        throw new Error("Please, provide missing data");
      d({
        message: "Generation successfully started",
        variant: "success"
      }), s(), t();
    } catch {
      d({
        message: "Something went wrong",
        variant: "error"
      });
    }
  };
  return V(() => {
    r.prompt && o((f) => ({
      ...f,
      prompt: r.prompt,
      domain: (r == null ? void 0 : r.domain) || [],
      standard: (r == null ? void 0 : r.standard) || [],
      vocabulary: (r == null ? void 0 : r.vocabulary) || []
    }));
  }, [r.prompt]), V(() => {
    h !== S.IN_PROGRESS && !(r != null && r.prompt) && c && o(
      (f) => f.prompt ? f : { ...f, prompt: c }
    );
  }, [h, r == null ? void 0 : r.prompt, c]), h === S.IN_PROGRESS || h === S.INITIAL && C !== Ke.IN_PROGRESS && C != null ? /* @__PURE__ */ e.jsx(U, { textAlign: "center", mt: 4, children: /* @__PURE__ */ e.jsx(Et, { color: "secondary" }) }) : /* @__PURE__ */ e.jsx(U, { p: 2, children: /* @__PURE__ */ e.jsx(Se, { outlined: !0, elevated: !0, children: /* @__PURE__ */ e.jsxs(x, { container: !0, pb: 0.5, spacing: 2, children: [
    /* @__PURE__ */ e.jsx(x, { item: !0, xs: 12, children: /* @__PURE__ */ e.jsx(nt, { name: "prompt", textLabel: "Prompt", required: !0, children: /* @__PURE__ */ e.jsx(
      bt,
      {
        id: "prompt",
        name: "prompt",
        type: "text",
        size: "medium",
        value: i.prompt,
        placeholder: "Enter prompt for generation",
        onChange: m,
        fullWidth: !0,
        multiline: !0,
        minRows: 6,
        maxRows: 20
      }
    ) }) }),
    /* @__PURE__ */ e.jsx(x, { item: !0, xs: 6, children: /* @__PURE__ */ e.jsx(nt, { name: "domain", textLabel: "Domain", children: /* @__PURE__ */ e.jsx(
      Ue,
      {
        id: "domain",
        name: "domain",
        options: ((y = p == null ? void 0 : p.domains) == null ? void 0 : y.filter(
          (f) => {
            var I;
            return !((I = i.domain) != null && I.some(
              (b) => b.value === f.value
            ));
          }
        )) || [],
        value: i.domain,
        multiple: !0,
        placeholder: (P = i.domain) != null && P.length ? "" : "Any",
        onChange: (f, I) => {
          u("domain", I);
        },
        fullWidth: !0,
        isOptionEqualToValue: (f, I) => f.value === I,
        getOptionLabel: (f) => Tt(f, (p == null ? void 0 : p.domains) || []),
        loading: g === S.IN_PROGRESS
      }
    ) }) }),
    /* @__PURE__ */ e.jsx(x, { item: !0, xs: 6, children: /* @__PURE__ */ e.jsx(nt, { name: "standard_concept", textLabel: "Standard Concept", children: /* @__PURE__ */ e.jsx(
      Ue,
      {
        id: "standard_concept",
        name: "standard_concept",
        options: ((j = p == null ? void 0 : p.standard_concepts) == null ? void 0 : j.filter(
          (f) => {
            var I;
            return !((I = i.standard) != null && I.some(
              (b) => b.value === f.value
            ));
          }
        )) || [],
        value: i.standard,
        placeholder: (N = i.standard) != null && N.length ? "" : "Any",
        multiple: !0,
        onChange: (f, I) => {
          u("standard", I);
        },
        fullWidth: !0,
        isOptionEqualToValue: (f, I) => f.value === I,
        getOptionLabel: (f) => Tt(f, (p == null ? void 0 : p.standard_concepts) || []),
        loading: g === S.IN_PROGRESS
      }
    ) }) }),
    /* @__PURE__ */ e.jsx(x, { item: !0, xs: 6, children: /* @__PURE__ */ e.jsx(nt, { name: "vocabulary", textLabel: "Vocabulary", children: /* @__PURE__ */ e.jsx(
      Ue,
      {
        id: "vocabulary",
        name: "vocabulary",
        options: ((v = p == null ? void 0 : p.vocabularies) == null ? void 0 : v.filter(
          (f) => {
            var I;
            return !((I = i.vocabulary) != null && I.some(
              (b) => b.value === f.value
            ));
          }
        )) || [],
        value: i.vocabulary,
        multiple: !0,
        placeholder: (w = i.vocabulary) != null && w.length ? "" : "Any",
        onChange: (f, I) => {
          u("vocabulary", I);
        },
        fullWidth: !0,
        isOptionEqualToValue: (f, I) => f.value === I,
        getOptionLabel: (f) => Tt(f, (p == null ? void 0 : p.vocabularies) || []),
        loading: g === S.IN_PROGRESS
      }
    ) }) }),
    /* @__PURE__ */ e.jsxs(x, { item: !0, xs: 12, children: [
      /* @__PURE__ */ e.jsx(qe, {}),
      /* @__PURE__ */ e.jsxs(
        U,
        {
          display: "flex",
          pt: 2,
          justifyContent: "end",
          sx: {
            "*:not(:first-of-type)": { marginLeft: 1 }
          },
          children: [
            /* @__PURE__ */ e.jsx(
              ge,
              {
                iconName: "close",
                title: "Cancel",
                color: "secondary",
                noCollapse: !0,
                onClick: t
              }
            ),
            /* @__PURE__ */ e.jsx(
              ge,
              {
                iconName: "submit",
                title: "Submit",
                color: "success",
                noCollapse: !0,
                disabled: !i.prompt || E === S.IN_PROGRESS || C === Ke.IN_PROGRESS,
                onClick: R,
                loading: E === S.IN_PROGRESS
              }
            )
          ]
        }
      )
    ] })
  ] }) }) });
}, Ko = Te((t) => {
  const { name: n, config: s, ...a } = t, {
    concept: c,
    selectedConcepts: d = {},
    onFind: C,
    onClose: h,
    onChange: E,
    onFinish: r,
    onAdd: l,
    onAddConcepts: i,
    concepts: o,
    conceptSetId: p,
    domainId: g,
    standardConcept: m,
    methodIncluded: u,
    filtersIncluded: R,
    vocabularyMode: y,
    outerUpdate: P,
    viewMode: j,
    versionId: N,
    typeContainer: v,
    parentId: w,
    mode: f,
    value: I,
    placeholder: b,
    showSelectAll: M,
    suggestionStatus: k,
    delta: H,
    entity: Y,
    ...Z
  } = s;
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    n === "vocabulary-concept" && /* @__PURE__ */ e.jsx(
      _t,
      {
        ...a,
        entryConcept: c,
        onClose: h,
        onFind: C,
        vocabularyMode: y,
        viewMode: j,
        typeContainer: v,
        parentId: w
      }
    ),
    n === "expression-concepts" && /* @__PURE__ */ e.jsx(
      Ho,
      {
        ...a,
        onChange: E,
        concepts: o,
        outerUpdate: P,
        viewMode: j,
        typeContainer: v,
        parentId: w,
        mode: f
      }
    ),
    n === "included-concepts" && /* @__PURE__ */ e.jsx(
      tn,
      {
        ...a,
        ...Z,
        onChange: E,
        concepts: o,
        onFinish: r,
        method: u,
        filtersMethod: R,
        viewMode: j,
        conceptSetId: p,
        versionId: N,
        listType: Qe.INCLUDED_CONCEPTS
      }
    ),
    n === "included-concepts-source-codes" && /* @__PURE__ */ e.jsx(
      tn,
      {
        ...a,
        ...Z,
        onChange: E,
        concepts: o,
        onFinish: r,
        method: u,
        filtersMethod: R,
        viewMode: j,
        conceptSetId: p,
        versionId: N,
        listType: Qe.INCLUDED_SOURCE_CODES
      }
    ),
    n === "add-import-concepts-widget" && /* @__PURE__ */ e.jsx(
      $o,
      {
        ...a,
        onFind: i,
        domainId: g,
        standardConcept: m
      }
    ),
    n === "add-concepts-widget" && /* @__PURE__ */ e.jsx(
      js,
      {
        ...a,
        onAdd: i,
        domainId: g,
        standardConcept: m,
        value: I,
        standard: !0,
        placeholder: b,
        showSelectAll: M
      }
    ),
    n === "ai-suggested-concepts" && /* @__PURE__ */ e.jsx(
      Wo,
      {
        viewMode: j,
        id: p,
        concepts: o,
        onChange: E,
        onFinish: r,
        suggestionStatus: k,
        delta: H
      }
    ),
    n === "ai-suggest-dialog" && /* @__PURE__ */ e.jsx(
      Yo,
      {
        onClose: h,
        id: p,
        onFinish: r,
        suggestionStatus: k,
        conceptSetName: Y == null ? void 0 : Y.name
      }
    )
  ] });
}), qo = {
  breadcrumbs: (t) => [
    {
      name: "Vocabulary",
      path: t
    }
  ]
}, Xo = Te(() => {
  const t = Ge(), n = et(), s = rs(), { path: a, storage: c, subModules: d } = pt(
    Dn
  ), { breadcrumbs: C } = qo, h = c, {
    selectedConcepts: E,
    detectSelectedAction: r,
    init: l,
    updateSelectedConceptBulk: i,
    clear: o
  } = _e((h == null ? void 0 : h.selectedElements) || {});
  V(() => {
    s(us(C(a)));
  }, []);
  const p = fe.useCallback(
    (R) => r(
      Ie(R, E)
    ),
    [E]
  ), g = () => {
    t("modal/selected");
  }, m = (R) => {
    t(`modal/related/${R.conceptId}`);
  }, u = () => {
    const R = n.state;
    if (R != null && R.closeTo) {
      t(R.closeTo, { replace: !0 });
      return;
    }
    t(`/${a}`);
  };
  return /* @__PURE__ */ e.jsx(x, { container: !0, px: 6, minHeight: "inherit", alignContent: "flex-start", children: /* @__PURE__ */ e.jsx(En, { children: /* @__PURE__ */ e.jsxs(
    at,
    {
      path: "*",
      element: /* @__PURE__ */ e.jsx(
        On,
        {
          onRowClickAction: m,
          onSubmitAction: p,
          vocabularyMode: !0,
          openSelectedArea: g,
          draftSelectedConceptsCount: Object.keys(E).length
        }
      ),
      children: [
        /* @__PURE__ */ e.jsx(
          at,
          {
            path: "modal/related/:conceptId",
            element: /* @__PURE__ */ e.jsx(Ye, { open: !0, onClose: u, children: /* @__PURE__ */ e.jsx(
              _t,
              {
                onClose: u,
                subModules: d,
                vocabularyMode: !0,
                path: a,
                onFind: p
              }
            ) })
          }
        ),
        /* @__PURE__ */ e.jsx(
          at,
          {
            path: "modal/selected",
            element: /* @__PURE__ */ e.jsx(Ye, { open: !0, onClose: u, children: /* @__PURE__ */ e.jsx(
              uo,
              {
                onChange: i,
                onChangeBulk: l,
                concepts: E,
                subModules: d,
                pureClose: u,
                onClose: () => {
                  o(), u();
                },
                path: a
              }
            ) })
          }
        )
      ]
    }
  ) }) });
}), Dn = nn(null), Zo = (t) => {
  const { path: n, title: s, name: a, initStorage: c, rootSettings: d } = t, [C, h] = F(d), [E, r] = F(!0);
  return V(() => {
    d || h({
      rootPath: n,
      rootTitle: s
    }), r(!1), document.title = "Prometheus - Vocabulary";
  }, []), E ? /* @__PURE__ */ e.jsx(At, { children: /* @__PURE__ */ e.jsx(Et, { size: 32 }) }) : /* @__PURE__ */ e.jsx(Dn.Provider, { value: { ...t, rootSettings: C }, children: /* @__PURE__ */ e.jsx(Xo, {}) });
}, da = (t) => {
  const { type: n } = t;
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    !n && /* @__PURE__ */ e.jsx(Zo, { ...t }),
    n === "component" && /* @__PURE__ */ e.jsx(Ko, { ...t })
  ] });
};
export {
  da as Vocabulary
};
